// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:34:59.285Z
// Property: Latitude at Mallard Creek (ID: 5653950229381120)
// Collections: 20 amenities, 17 floorplans (live), 16 photos, 78 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5653950229381120",
  "property_external_id": "4897194",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/latitude-at-mallard-creek-charlotte-nc/5hd0mwq",
  "property_google_business_url": "https://www.google.com/maps/place/Latitude+at+Mallard+Creek/@35.3268844,-80.735453,15z/data=!4m2!3m1!1s0x0:0x6117843eb2cb3df8?sa=X&ved=2ahUKEwi_gYK3jOL2AhXmmWoFHRNUBI4Q_BJ6BAgsEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443889465",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "latitude-at-mallard-creek",
  "property_name": "Latitude at Mallard Creek",
  "property_website_url": "https://www.latitudeatmc.com/",
  "property_domain": "https://www.latitudeatmc.com/",
  "property_address": "655 W Mallard Creek Church Rd",
  "property_full_address": "655 W Mallard Creek Church Rd, Charlotte, NC 28262",
  "property_address_1": "655 W Mallard Creek Church Rd",
  "property_address_2": null,
  "property_address_city": "Charlotte",
  "property_address_state": "NC",
  "property_address_zip_full": "28262-2418",
  "property_address_zip": "28262",
  "property_address_country": "US",
  "property_address_county": "Mecklenburg County",
  "property_neighborhood_address": "University City North",
  "property_address_latitude": "35.3269135",
  "property_address_longitude": "-80.73545589999999",
  "property_email": "latitude@alapts.com",
  "property_phone": "(980) 819-5503",
  "property_call_tracking_phone": "980-575-1228",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern comfort in University City North.</strong> Explore polished one-, two-, and three-bedroom apartments with standout finishes, easy everyday conveniences, and resort-inspired spaces—then view <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Latitude at Mallard Creek in person.</p>",
  "property_long_description": "<p><strong>Modern comfort in University City North.</strong> At Latitude at Mallard Creek, you get a polished Charlotte apartment setting with one-, two-, and three-bedroom layouts, everyday conveniences, and a location that keeps the area’s best connections close. Inside, enjoy granite countertops, stainless steel appliances, wood-style flooring, generous closets, in-home laundry, and covered balconies in select homes.</p><p>Step outside for <a href=\"/amenities\">resort-inspired amenities</a> designed for easy downtime: a sparkling pool, poolside summer kitchen, social room and coffee bar, 24-hour fitness center, work lounge, WiFi hotspots, plus a dog park and dog wash. When you’re ready to explore, UNC Charlotte, JW Clay/UNC Charlotte Station, The Boardwalk at University Place, Mallard Creek Greenway, and University Research Park are all part of the nearby rhythm—putting dining, transit, trails, campus energy, and North Charlotte conveniences within easy reach.</p><p>Find the space that fits how you live on the <a href=\"/floor-plans\">floor plans</a> page or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Latitude at Mallard Creek in person.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019d02ef-a03d-730a-bc29-837ac8f25a3b.webp",
  "property_featured_image_media": {
    "alt_text": "A modern living room with an orange sofa, black armchair, coffee table, and dining table.",
    "public_id": "019d02ef-a03d-730a-bc29-837ac8f25a3b",
    "storage_key": "property/5653950229381120/019d02ef-a03d-730a-bc29-837ac8f25a3b.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "503",
  "property_year_built": "2013",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.02385685884693",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": "Application Fee $85\nAdministrative Fee $250\nNon-Refundable Pet Fee $400 / pet\nMonthly Pet Rent $40 / pet\nApplication Approval Fee Starting At $300\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $40 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $40 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8786074.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://latitudeatmallardcreek.loftliving.com/login",
  "property_apply_now_url": "https://8786074.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e6fc5-30f7-77d7-a65d-aee4ade446f7.webp",
  "property_primary_logo_media": {
    "alt_text": "Latitude Mallard Creek logo",
    "public_id": "019e6fc5-30f7-77d7-a65d-aee4ade446f7",
    "storage_key": "property/5653950229381120/019e6fc5-30f7-77d7-a65d-aee4ade446f7.webp",
    "width": 1129,
    "height": 387
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e6fc5-312b-70cc-a661-261c51bc818c.webp",
  "property_secondary_logo_media": {
    "alt_text": "Latitude Mallard Creek logo",
    "public_id": "019e6fc5-312b-70cc-a661-261c51bc818c",
    "storage_key": "property/5653950229381120/019e6fc5-312b-70cc-a661-261c51bc818c.webp",
    "width": 1129,
    "height": 387
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e6fc5-3106-75de-bc0d-9c048761d6af.webp",
  "property_icon_media": {
    "alt_text": "Abstract logo with a green square inside another green square, with a L shape in between.",
    "public_id": "019e6fc5-3106-75de-bc0d-9c048761d6af",
    "storage_key": "property/5653950229381120/019e6fc5-3106-75de-bc0d-9c048761d6af.webp",
    "width": 560,
    "height": 561
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e6fc5-3106-75de-bc0d-9c048761d6af.webp",
  "property_fav_icon_media": {
    "alt_text": "Abstract logo with a green square inside another green square, with a L shape in between.",
    "public_id": "019e6fc5-3106-75de-bc0d-9c048761d6af",
    "storage_key": "property/5653950229381120/019e6fc5-3106-75de-bc0d-9c048761d6af.webp",
    "width": 560,
    "height": 561
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e6fc5-3107-7502-aaf9-40cbd7c18c94.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Latitude Mallard Creek logo",
    "public_id": "019e6fc5-3107-7502-aaf9-40cbd7c18c94",
    "storage_key": "property/5653950229381120/019e6fc5-3107-7502-aaf9-40cbd7c18c94.webp",
    "width": 1129,
    "height": 387
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e6fc5-30fd-734b-a0ca-6275dca872e2.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Latitude Mallard Creek logo",
    "public_id": "019e6fc5-30fd-734b-a0ca-6275dca872e2",
    "storage_key": "property/5653950229381120/019e6fc5-30fd-734b-a0ca-6275dca872e2.webp",
    "width": 1129,
    "height": 387
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#a2a827",
  "property_secondary_color": "#5f6569",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#879036",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "609 - 1406",
  "property_sqft_min": "609",
  "property_sqft_max": "1406",
  "property_price_range": "1205 - 1835",
  "property_price_min": "1205",
  "property_price_max": "1835",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/LatitudeMallardCreek",
  "property_instagram_url": "https://www.instagram.com/latitudeatmallardcreekapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJIcDh324cVIgR-D3Lsj6EF2E",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/phillips-mallard-creek-apartments-charlotte",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Spaces that keep the day moving.</strong> Break a sweat in the 24-hour fitness center, plug in at the WiFi work lounge, then reset by the outdoor pool and poolside summer kitchen. Latitude at Mallard Creek also brings everyday ease with a clubhouse, dog park and dog wash, covered parking options, and polished apartment finishes like granite countertops, stainless-steel appliances, wood-style flooring, walk-in closets, and in-home laundry.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit in University City North.</strong> Choose from one-, two-, and three-bedroom apartments at Latitude at Mallard Creek, with layouts ranging from efficient and easy to furnish to spacious homes with room to spread out. Inside, polished finishes like granite countertops, stainless steel appliances, wood-style flooring, generous closets, in-home laundry, and select covered balconies make every floor plan feel considered.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview life in focus.</strong> Explore bright kitchens with granite countertops and stainless steel appliances, open living spaces with wood-style flooring, and balconies that extend your view. The gallery also captures the freeform pool, poolside summer kitchen, clubhouse, coffee bar, and work lounge—plus everyday conveniences like in-home laundry, roomy closets, and select wooded or pool views.</p>",
  "property_home_neighborhood_blurb": "<p><strong>University City North, connected to what’s next.</strong> Latitude at Mallard Creek puts UNC Charlotte, University Research Park, and JW Clay/UNC Charlotte Station within easy reach, with Blue Line access to NoDa and Uptown. Nearby, The Boardwalk at University Place adds lakeside dining and errands, while Mallard Creek and Clark’s Creek greenways bring paved trails into the routine. Concerts at PNC Music Pavilion, shopping at Concord Mills, and home-base amenities are all part of the map.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say Latitude at Mallard Creek feels easy to love.</strong> Reviews often point to responsive management, fast maintenance, and a team that brings genuine care to daily life. Polished finishes—stainless steel appliances, granite countertops, and wood flooring—stand out, along with conveniences like the fitness center and coffee stop. See why one resident described the community as feeling “comfortable and at home.”</p>",
  "property_neighborhood_blurb": "<p><strong>North Charlotte, mapped for your everyday plans.</strong> From Latitude at Mallard Creek, University City North puts you close to the momentum of UNC Charlotte, the offices and innovation around University Research Park, and the Blue Line connections at JW Clay/UNC Charlotte Station—so a dinner in NoDa or a night in Uptown can start with a simple ride.</p><p>Closer to home, The Boardwalk at University Place brings lakeside dining and quick errands into the mix, while Mallard Creek and Clark’s Creek greenways add paved trails for fresh-air breaks. Catch a concert at PNC Music Pavilion, shop at Concord Mills, or come back to your pool, lounge, and work-ready spaces. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the neighborhood fits your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that move with your day.</strong> Start with a workout in the 24-hour fitness center, settle into the work lounge with WiFi, then unwind by the outdoor pool and poolside summer kitchen. At Latitude at Mallard Creek, shared spaces are designed for easy transitions—coffee at the clubhouse, a refresh at the dog park and dog wash, or a quieter moment on a covered balcony in select homes.</p><p>Inside, your apartment keeps the same polished rhythm with granite countertops, stainless-steel appliances, modern chrome fixtures, wood-style flooring, walk-in closets, and in-home laundry. Covered parking options, online resident services, and available accessible homes add practical convenience to the everyday. See more in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Latitude at Mallard Creek home?</strong><br>Start your online application for a modern Charlotte apartment with polished finishes, practical layouts, and everyday conveniences designed to simplify your routine. Choose the space that fits, then take the next step toward calling University City North home.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong> Contact the leasing team at Latitude at Mallard Creek for details about available one-, two-, and three-bedroom apartments, everyday conveniences, or directions to our University City North location. We’d be happy to help you plan your next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Latitude at Mallard Creek?</strong> Start here for quick answers about the community, leasing, amenities, and everyday living in our Charlotte apartments. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the space that works.</strong> Latitude at Mallard Creek offers one-, two-, and three-bedroom apartments in University City North, with choices that range from efficient, easy-to-furnish layouts to larger homes with extra room to spread out.</p><p>As you compare floor plans, look for the details that make daily living feel polished: sleek granite countertops, stainless steel appliances, wood-style flooring, generous closet space, in-home washer and dryer, and select covered balconies. Accessible layouts are available, and some homes feature pool or wooded views. Browse current pricing and availability below, then explore the <a href=\"/amenities\">apartment features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See the details come into focus.</strong> Browse the Latitude at Mallard Creek photo gallery for a closer look at the spaces that shape everyday living here—from bright kitchens with granite countertops and stainless steel appliances to open living areas with wood-style flooring and easy balcony access.</p><p>Picture a sunny afternoon by the freeform pool, a shaded seat near the poolside summer kitchen, or a quiet reset in the clubhouse, coffee bar, and work lounge. You’ll also spot practical details like in-home laundry, generous closet space, and available wooded or pool views in select apartments. After the gallery, compare <a href=\"/floor-plans\">one-, two-, and three-bedroom layouts</a>, explore more <a href=\"/amenities\">community amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Latitude at Mallard Creek in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore the map.</strong> See how Latitude at Mallard Creek connects polished apartment living with University City North dining, transit, trails, campus energy, and North Charlotte conveniences—then check available homes and nearby highlights all in one place.</p>",
  "property_pets_blurb": "<p><strong>Bring the tail wags home.</strong> At Latitude at Mallard Creek, your pet-friendly apartment lifestyle comes with more than a welcome mat. Cats and dogs can settle in comfortably, with room for up to two pets per home and no weight limit, while breed restrictions may apply. For daily routines, the on-site <a href=\"/amenities\">dog park and dog wash</a> make playtime and cleanup easier without leaving the community.</p><p>Inside your apartment, wood-style flooring, generous closet space, in-home laundry, and select covered balconies help everyday life feel simple after muddy walks, bath days, and weekend outings. When you want extra fresh air, nearby greenway connections around University City North add convenient places to stretch your legs together. Have questions about your pet’s fit? <a href=\"/contact-us\">Contact the leasing team</a> for current policy details.</p>",
  "property_referafriend_blurb": "<p><strong>Share Latitude at Mallard Creek.</strong> Know someone who’d love modern Charlotte apartment living with polished finishes, everyday conveniences, and resort-inspired spaces for downtime? Send them our way and invite them to experience the comfort, connection, and easy University City North rhythm you enjoy here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Latitude at Mallard Creek.</strong><br>Manage everyday apartment needs in one convenient place. Log in to pay rent, submit maintenance requests, and keep your account current—so you can get back to enjoying modern comfort, everyday conveniences, and resort-inspired downtime in University City North.</p>",
  "property_reviews_blurb": "<p><strong>See Latitude at Mallard Creek through resident experiences.</strong> As you browse the reviews, you’ll notice recurring praise for responsive management, quick maintenance, and a welcoming sense of care from the team.</p><p>Residents highlight polished apartment finishes like stainless steel appliances, granite countertops, and wood flooring, along with community spaces that make everyday routines easier. The fitness center and coffee stop earn frequent mentions, and one reviewer sums up the feeling simply: “feel comfortable and at home.” Read on to see what current and past residents have shared about life at Latitude at Mallard Creek.</p>",
  "property_created_at": "1752256408255",
  "property_scheduletour_blurb": "<p><strong>See Latitude at Mallard Creek up close.</strong> Tour polished one-, two-, and three-bedroom apartments with granite countertops, stainless steel appliances, wood-style flooring, generous closets, and in-home laundry. Explore the spaces, finishes, and everyday conveniences in person—then find the layout that feels right. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we’ve received your inquiry.</strong><br>Our leasing team will be in touch soon. In the meantime, picture polished Charlotte living with spacious one-, two-, and three-bedroom layouts, modern finishes, everyday conveniences, and resort-inspired spaces designed for easy downtime at Latitude at Mallard Creek.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through Latitude at Mallard Creek before you arrive.</strong> Explore immersive virtual tours that let you move through the community, clubhouse, coworking space, fitness center, and pool at your own pace. Then step inside available apartment walkthroughs, including one-, two-, and three-bedroom layouts such as 1A, 1B, A2, 2A, 2B, 2C, and C1, to compare flow, finishes, kitchen space, closet potential, and balcony connections from wherever you are.</p><p>Use each tour to narrow your favorites, revisit details, and picture how the spaces feel beyond photos. When you are ready for the next look, compare <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Latitude at Mallard Creek in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Latitude at Mallard Creek",
  "property_seo_title_home": "Latitude at Mallard Creek | Apartments in Charlotte, NC",
  "property_seo_description_home": "Discover your dream home at Latitude at Mallard Creek in Charlotte, NC! Choose from spacious one, two, and three-bedroom floor plans featuring upscale amenities like a sparkling pool, fitness center, and a dog park. Enjoy the convenience of online resident services, stylish interiors with tall ceilings and vinyl plank flooring, and a vibrant clubhouse with a coffee bar. With covered parking and easy access to local attractions, your perfect apartment awaits! Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Charlotte, NC",
  "property_seo_description_floorplans": "Discover your ideal living space at Latitude at Mallard Creek in Charlotte, NC! Explore our diverse floor plans, featuring stylish one, two, and three-bedroom options designed to suit your lifestyle. Browse our available apartment homes and find your perfect floor plan today!",
  "property_seo_title_amenities": "Amenities | Charlotte, NC Apartments for Rent",
  "property_seo_description_amenities": "Discover the vibrant living experience at Latitude at Mallard Creek in Charlotte, NC! Explore our stunning one, two, and three-bedroom floor plans, each designed with modern amenities like tall ceilings, walk-in closets, and in-home W&D. Enjoy our resort-style community features, including a clubhouse, fitness center, coffee bar, and a sparkling pool. Plus, your furry friends will love the dog park! Dive into our exceptional lifestyle and see all we have to offer. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Charlotte, NC",
  "property_seo_description_gallery": "Discover your dream home at Latitude at Mallard Creek in Charlotte, NC. Explore our stunning photo gallery showcasing beautifully designed one, two, and three-bedroom floor plans featuring modern amenities like a fitness center, inviting clubhouse, and serene dog park. Enjoy the convenience of online resident services and relax by the pool or in our outdoor spaces. Picture yourself living in comfort with tall ceilings, walk-in closets, and stylish fixtures. Join our community and experience the lifestyle you deserve—view our gallery today!",
  "property_seo_title_virtualtours": "Virtual Tours | Latitude at Mallard Creek Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Latitude at Mallard Creek in Charlotte, NC! Explore our spacious one, two, and three-bedroom floor plans and experience the inviting atmosphere of our vibrant community. Take a virtual tour today and find your dream apartment for rent!",
  "property_seo_title_interactivemap": "Interactive Map | Latitude at Mallard Creek Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at Latitude at Mallard Creek in Charlotte, NC! Explore our stunning one, two, and three-bedroom floor plans equipped with top-notch amenities like a fitness center, dog park, and serene pool area. Enjoy modern living with walk-in closets, high ceilings, and stylish finishes. Check out our upcoming features, including a clubhouse and community kitchen. Use our interactive community map to search for available apartments, view pricing, and make the best choice for your new lifestyle. Your perfect apartment awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Charlotte, NC",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Latitude at Mallard Creek in Charlotte, NC! Explore our spacious one, two, and three-bedroom floor plans, and see what exciting local favorites and points of interest are just around the corner. Start your next adventure today and find out why our community is the perfect place to call home!",
  "property_seo_title_contact": "Contact Us | Latitude at Mallard Creek",
  "property_seo_description_contact": "Discover your perfect home at Latitude at Mallard Creek in Charlotte, NC! Explore our diverse floor plans, featuring spacious one, two, and three-bedroom apartments designed for comfort and style. Have questions? Contact our leasing team today for personalized assistance and let us help you find your ideal living space!",
  "property_seo_title_faqs": "FAQs | Apartments in Charlotte, NC",
  "property_seo_description_faqs": "Discover the answers to your questions at Latitude at Mallard Creek in Charlotte, NC! Our frequently asked questions page covers everything you need to know about our spacious floor plans—including one, two, and three-bedroom options—as well as exciting amenities like a pool, fitness center, dog park, and more. Enjoy convenient online resident services and explore our vibrant community. Browse our FAQs now to learn how Latitude at Mallard Creek can enhance your living experience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Charlotte, NC",
  "property_seo_description_reviews": "Discover why residents love calling Latitude at Mallard Creek home in Charlotte, NC! Explore our modern one, two, and three-bedroom floor plans, complemented by outstanding amenities like a fitness center, dog park, and inviting clubhouse. Enjoy luxurious features like tall ceilings, walk-in closets, and W&D included, alongside convenient online resident services. Dive into our community's vibrant lifestyle and see what our residents have to say! Check out their reviews and make Latitude your next home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Charlotte, NC",
  "property_seo_description_applynow": "Discover your ideal living space at Latitude at Mallard Creek in Charlotte, NC! Explore our diverse floor plans, featuring one, two, and three-bedroom options tailored to your lifestyle. Enjoy a wealth of amenities, including a clubhouse, fitness center, dog park, and a refreshing pool with stunning views. With online resident services and covered parking, convenience is at your fingertips. Apply now and find your new home - lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Latitude at Mallard Creek",
  "property_seo_description_residentaccess": "\"Welcome to Latitude at Mallard Creek in Charlotte, NC! Access your resident portal now to effortlessly pay rent, schedule maintenance, and manage your community needs. Enjoy a seamless living experience today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Latitude at Mallard Creek",
  "property_seo_description_referafriend": "Discover a vibrant community at Latitude at Mallard Creek in Charlotte, NC! Great friends make great neighbors—refer a friend today and enjoy exclusive rewards. Join us in creating a welcoming environment where comfort meets connection!",
  "property_seo_title_scheduletour": "Schedule a Tour | Latitude at Mallard Creek",
  "property_seo_description_scheduletour": "Discover your perfect home at Latitude at Mallard Creek in beautiful Charlotte, NC! Schedule a tour today to explore our stunning apartments, luxurious amenities, and vibrant community. Don’t miss your chance to experience the lifestyle you deserve!",
  "property_seo_title_privacy": "Privacy Policy | Latitude at Mallard Creek",
  "property_seo_description_privacy": "\"Discover peace of mind at Latitude at Mallard Creek in Charlotte, NC. Our privacy policy ensures your personal information is protected while you enjoy our vibrant apartment community. View our privacy policy to learn more about how we prioritize your privacy.\"",
  "property_seo_title_accessibility": "Website Accessibility | Latitude at Mallard Creek",
  "property_seo_description_accessibility": "Discover the Accessibility Statement for Latitude at Mallard Creek in Charlotte, NC. We prioritize digital inclusion and strive to ensure that every resident and visitor can easily access our community resources. Learn more about our commitment to accessibility and how we support all individuals in our vibrant apartment community. Visit us today!",
  "property_seo_title_sitemap": "Sitemap | Latitude at Mallard Creek",
  "property_seo_description_sitemap": "Discover the full range of amenities and options at Latitude at Mallard Creek in Charlotte, NC. Our sitemap offers an easy way to navigate our vibrant apartment community. Dive in and explore your future home today!",
  "property_seo_title_thankyou": "Thank You | Latitude at Mallard Creek",
  "property_seo_description_thankyou": "Thank you for your interest in Latitude at Mallard Creek, the premier apartment community in Charlotte, NC! A member of our team will reach out shortly to assist you with your inquiries. Discover your perfect home with us!",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651137147",
  "amenities": [
    {
      "id": "custom_bb7c30eb-3413-482f-b714-c6599348e536",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryer*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c1b01269-3092-4037-afd2-368805b5c9ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Spacious Covered Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d59069b7-7f38-4ab4-a582-7a39d0255c9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Closet Space",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f2c91b45-bd9d-4377-8307-b52556e503d1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a211bd6a-2d31-49f3-aed1-ac3d61fe0e44",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000636",
      "title": "Fixtures",
      "amount": "0.0000",
      "description": "Modern Chrome Fixtures",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2b45e324-ab39-47d6-a28f-bba77a81fa3a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4a6a822a-df98-4bdb-8276-81f304698970",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c23bd839-6f8a-4932-85c2-038f33e33f75",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9` Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a7b73bfe-e82a-49ed-9a4c-bf391314ad33",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000618",
      "title": "Convenient Access",
      "amount": "0.0000",
      "description": "ADA Accessible Units Available",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8438c527-2c3a-444d-a166-4faa3527df25",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000615",
      "title": "Coffee Bar",
      "amount": "0.0000",
      "description": "Social Room & Coffee Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b96022d0-9fb5-4bfa-a684-fad22c8cf095",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_64b4575b-a424-4ff2-9953-bdb46636009e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000002364",
      "title": "Community Kitchen",
      "amount": "0.0000",
      "description": "Poolside Summer Kitchen",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f3660b5c-8fdb-4c6f-ad29-af7e6181519c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool w/Cabanas",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_81145fcc-d715-4ece-907e-cd9a4b3d3cca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Dog Park & Dog Wash",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c5b29591-0081-4574-8803-35336e50058d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000623",
      "title": "Covered Parking",
      "amount": "0.0000",
      "description": "Covered Parking Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f97a6732-ce44-450c-bb0d-0698d6bf2767",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000708",
      "title": "Wifi",
      "amount": "0.0000",
      "description": "WiFi Hotspots",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e091a9cb-b18d-45c2-8c57-f809915452d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000001372",
      "title": "Lounge",
      "amount": "0.0000",
      "description": "Work Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_de604095-afd8-4faf-ada9-7ff93f8678bc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000614",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Resident Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3e7cfefa-3158-4133-a8cc-d21c057cd155",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b0781cfa-5a56-4c33-af92-1d52c0b8f898",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_cbd097b4-7195-416b-baf1-6e2b7f01cc8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-6a26-73da-8ae8-06768f39a80d.webp",
      "image_media": {
        "alt_text": "Living room and dining area with orange sofa, coffee table, and dining set.",
        "public_id": "019e899e-6a26-73da-8ae8-06768f39a80d",
        "storage_key": "property/5653950229381120/019e899e-6a26-73da-8ae8-06768f39a80d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a modern orange sofa, a stylish coffee table, and a chic dining set. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room and dining area with orange sofa, coffee table, and dining set.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a4605481-1312-457d-8044-5c19d8bbb39b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-6a2b-7779-b857-a93fcc468e4c.webp",
      "image_media": {
        "alt_text": "Community lounge area with comfortable seating, a coffee table, and a bar with stools.",
        "public_id": "019e899e-6a2b-7779-b857-a93fcc468e4c",
        "storage_key": "property/5653950229381120/019e899e-6a2b-7779-b857-a93fcc468e4c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring ample seating, a modern coffee table, and a fully equipped bar area perfect for socializing.",
      "link": "",
      "alt_text": "Community lounge area with comfortable seating, a coffee table, and a bar with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_776b2fd8-3dd1-4e2f-9323-2740b01c89ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-69b2-7188-ac9f-cd2d01d7a759.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with agility equipment, benches, and artificial turf.",
        "public_id": "019e899e-69b2-7188-ac9f-cd2d01d7a759",
        "storage_key": "property/5653950229381120/019e899e-69b2-7188-ac9f-cd2d01d7a759.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy our community's dedicated dog park, complete with agility equipment and comfortable seating for pet owners.",
      "link": "",
      "alt_text": "A fenced-in dog park with agility equipment, benches, and artificial turf.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_06fbb20a-1f6f-4a97-b734-c74ee65a2d4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-5c01-7457-89bb-40f397eec668.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry room with shelving and a water heater.",
        "public_id": "019e899e-5c01-7457-89bb-40f397eec668",
        "storage_key": "property/5653950229381120/019e899e-5c01-7457-89bb-40f397eec668.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry with a washer, dryer, and overhead shelving for storage. A water heater is also visible.",
      "link": "",
      "alt_text": "Washer and dryer in a laundry room with shelving and a water heater.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f4abc252-d6d7-4aa8-b046-1629179d8378",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-58f6-7365-a59c-b8e075713891.webp",
      "image_media": {
        "alt_text": "Balcony with two wooden chairs and a small table overlooking a pool area.",
        "public_id": "019e899e-58f6-7365-a59c-b8e075713891",
        "storage_key": "property/5653950229381120/019e899e-58f6-7365-a59c-b8e075713891.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, complete with comfortable seating and scenic views of the community pool area.",
      "link": "",
      "alt_text": "Balcony with two wooden chairs and a small table overlooking a pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_78c6d835-ad7c-4bf9-b774-2b029383ce82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-5adc-768c-8526-017ab95ec746.webp",
      "image_media": {
        "alt_text": "Modern co-working space with comfortable seating, private offices, and a wet bar.",
        "public_id": "019e899e-5adc-768c-8526-017ab95ec746",
        "storage_key": "property/5653950229381120/019e899e-5adc-768c-8526-017ab95ec746.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover our sophisticated co-working lounge, featuring plush seating, private glass-enclosed offices for focused work, and a convenient wet bar area.",
      "link": "",
      "alt_text": "Modern co-working space with comfortable seating, private offices, and a wet bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_97cb07bd-ee6f-4cc8-9b7b-b653b97682e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-4293-7715-8692-58391e622d35.webp",
      "image_media": {
        "alt_text": "Latitude Mallard Creek package lockers",
        "public_id": "019e899e-4293-7715-8692-58391e622d35",
        "storage_key": "property/5653950229381120/019e899e-4293-7715-8692-58391e622d35.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Secure and convenient package lockers for residents at Latitude Mallard Creek.",
      "link": "",
      "alt_text": "Latitude Mallard Creek package lockers",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b67118a6-20bb-4c13-bdc6-129821c440a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-434c-759d-8e31-74d645cb72b4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and an open view to the living room.",
        "public_id": "019e899e-434c-759d-8e31-74d645cb72b4",
        "storage_key": "property/5653950229381120/019e899e-434c-759d-8e31-74d645cb72b4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience the ease of cooking and entertaining in this beautifully appointed kitchen, seamlessly flowing into a spacious living area.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and an open view to the living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eb42d093-e85d-4be0-8125-f78717e49560",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-4416-75fc-b764-51d1a225dfcd.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and clubhouse at a multifamily property.",
        "public_id": "019e899e-4416-75fc-b764-51d1a225dfcd",
        "storage_key": "property/5653950229381120/019e899e-4416-75fc-b764-51d1a225dfcd.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, perfect for relaxation and fun. Adjacent to the sparkling pool is a beautifully appointed clubhouse for resident enjoyment.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and clubhouse at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c6da9bca-32e4-4747-b1f8-5ac8e04384f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-43b5-75f5-88ea-f99394a5a60b.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with a granite countertop.",
        "public_id": "019e899e-43b5-75f5-88ea-f99394a5a60b",
        "storage_key": "property/5653950229381120/019e899e-43b5-75f5-88ea-f99394a5a60b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a clean, modern design with a white bathtub, a stylish shower curtain, a functional toilet, and a spacious vanity with ample storage.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_731f5e76-5467-462b-a870-21c15bf8aed2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-3eae-766f-ba19-664971767830.webp",
      "image_media": {
        "alt_text": "A bedroom with a queen-size bed, nightstands, and a dresser.",
        "public_id": "019e899e-3eae-766f-ba19-664971767830",
        "storage_key": "property/5653950229381120/019e899e-3eae-766f-ba19-664971767830.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy and inviting bedroom featuring a plush queen-size bed, stylish nightstands, and a modern dresser. Perfect for relaxation.",
      "link": "",
      "alt_text": "A bedroom with a queen-size bed, nightstands, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cd3817a0-6318-4b54-a250-b7f339b39336",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-3e3a-714d-ac8e-0b690be83580.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e899e-3e3a-714d-ac8e-0b690be83580",
        "storage_key": "property/5653950229381120/019e899e-3e3a-714d-ac8e-0b690be83580.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool, perfect for relaxing and soaking up the sun. Surrounded by comfortable lounge chairs and shaded umbrellas, it's the ideal spot for a refreshing escape.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_892222c2-5e0e-4c4b-b305-adf83d5b1dbf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-3ef8-7362-8508-26071d2bb72b.webp",
      "image_media": {
        "alt_text": "Modern apartment complex gym with treadmills, stair climbers, rowing machines, and stationary bikes.",
        "public_id": "019e899e-3ef8-7362-8508-26071d2bb72b",
        "storage_key": "property/5653950229381120/019e899e-3ef8-7362-8508-26071d2bb72b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio machines for a complete workout.",
      "link": "",
      "alt_text": "Modern apartment complex gym with treadmills, stair climbers, rowing machines, and stationary bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa933f06-4ece-40e3-a48d-3525f8acc2cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-3d85-773a-b1ea-e2d74f4bc563.webp",
      "image_media": {
        "alt_text": "Living room and kitchen in an apartment with modern furnishings.",
        "public_id": "019e899e-3d85-773a-b1ea-e2d74f4bc563",
        "storage_key": "property/5653950229381120/019e899e-3d85-773a-b1ea-e2d74f4bc563.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with a modern kitchen, perfect for entertaining guests or relaxing after a long day.",
      "link": "",
      "alt_text": "Living room and kitchen in an apartment with modern furnishings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f45d71d-510e-4faf-8f63-b04844eed532",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-37ac-735d-ac97-24f0e4756159.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
        "public_id": "019e899e-37ac-735d-ac97-24f0e4756159",
        "storage_key": "property/5653950229381120/019e899e-37ac-735d-ac97-24f0e4756159.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring granite countertops, stainless steel appliances, a large sink, and a breakfast bar with stools. Includes a dining area with a table and chairs.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e0511ed3-4d3a-4a22-9e8c-4da204e42cdd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e899e-37bc-724c-bd88-7cce363c2cef.webp",
      "image_media": {
        "alt_text": "Gym with exercise bikes, yoga balls, and weights.",
        "public_id": "019e899e-37bc-724c-bd88-7cce363c2cef",
        "storage_key": "property/5653950229381120/019e899e-37bc-724c-bd88-7cce363c2cef.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and healthy in our state-of-the-art fitness center, equipped with cardio machines, free weights, and more.",
      "link": "",
      "alt_text": "Gym with exercise bikes, yoga balls, and weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_2bf6e1a888cddc5a923967dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "BACHI",
      "poi_type": "Restaurants",
      "poi_address": "2700 W Mallard Creek Church Rd #200, Charlotte, NC 28262, USA",
      "poi_short_description": "Casual restaurant serving hibachi-grilled dishes, sushi and popular Filipino fare.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-16bc-75db-9513-0ae46b20840d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-16bc-75db-9513-0ae46b20840d",
        "storage_key": "property/5653950229381120/019f1505-16bc-75db-9513-0ae46b20840d.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "http://www.bachiclt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8541392054467520043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bachi",
      "poi_latitude": "35.3402701",
      "poi_longitude": "-80.76514159999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 980-819-7761",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0da8-764a-9549-3665682ab112",
        "storage_key": "property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsZFaya8dVIgRK2bhvdEeiXY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_89948fb03b219a70d409e321",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Teriyaki Madness",
      "poi_type": "Restaurants",
      "poi_address": "1100 Metropolitan Ave #130, Charlotte, NC 28204, USA",
      "poi_short_description": "Cheery counter-serve branch doling out rice & noodle bowls with Asian-style proteins & veggies.",
      "poi_long_description": "Cheery counter-serve branch doling out rice & noodle bowls with Asian-style proteins & veggies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-1720-758f-80eb-86ba832e449d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-1720-758f-80eb-86ba832e449d",
        "storage_key": "property/5653950229381120/019f1505-1720-758f-80eb-86ba832e449d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://teriyakimadness.com/locations/metropolitan/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9632905238721434829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "teriyaki-madness",
      "poi_latitude": "35.2127601",
      "poi_longitude": "-80.8357012",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "4 hours 0 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 704-910-2076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0da8-764a-9549-3665682ab112",
        "storage_key": "property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgZD9cIyfVogRzZT9_Eb0roU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_fusion_restaurant"
    },
    {
      "id": "ec_f3811a8326fb065b7f5cef23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "McAlister's Deli",
      "poi_type": "Restaurants",
      "poi_address": "2706 W Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Easygoing counter-service chain known for its sandwiches, stuffed baked potatoes & sweet tea.",
      "poi_long_description": "Easygoing counter-service chain known for its sandwiches, stuffed baked potatoes & sweet tea.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-1bdc-706b-951d-86e5458a973a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-1bdc-706b-951d-86e5458a973a",
        "storage_key": "property/5653950229381120/019f1505-1bdc-706b-951d-86e5458a973a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://locations.mcalistersdeli.com/nc/charlotte/2706-w-mallard-creek-church-rd?utm_source=google&utm_medium=organic&utm_campaign=locations_partner",
      "poi_directions_map_url": "https://maps.google.com/?cid=8555277494961104768&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcalisters-deli",
      "poi_latitude": "35.3405036",
      "poi_longitude": "-80.7653119",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-595-9993",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0da8-764a-9549-3665682ab112",
        "storage_key": "property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtTknRRQcVIgRgOcMyo1zunY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_8081ae65a9673b9afcaa33d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Firehouse Subs Mallard Creek",
      "poi_type": "Restaurants",
      "poi_address": "2700 W Mallard Creek Church Rd Ste 220, Charlotte, NC 28262, USA",
      "poi_short_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_long_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-1bec-71aa-a350-b65cd6c93eec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-1bec-71aa-a350-b65cd6c93eec",
        "storage_key": "property/5653950229381120/019f1505-1bec-71aa-a350-b65cd6c93eec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.firehousesubs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16090087587775117553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firehouse-subs-mallard-creek",
      "poi_latitude": "35.340214",
      "poi_longitude": "-80.764915",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-890-3695",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0da8-764a-9549-3665682ab112",
        "storage_key": "property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQVp0FQcVIgR8fhBgml5S98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_daeacc7b6a85900f84507e10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Cold Stone Creamery",
      "poi_type": "Restaurants",
      "poi_address": "2700 W Mallard Creek Church Rd Ste 210, Charlotte, NC 28262, USA",
      "poi_short_description": "Ice cream chain offering design-your-own creations hand-mixed on a granite slab, plus shakes & more.",
      "poi_long_description": "Ice cream chain offering design-your-own creations hand-mixed on a granite slab, plus shakes & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-1be7-753c-aed6-c90e3010f032.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-1be7-753c-aed6-c90e3010f032",
        "storage_key": "property/5653950229381120/019f1505-1be7-753c-aed6-c90e3010f032.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.coldstonecreamery.com/stores/21246?utm_source=gmb&utm_medium=gmb&utm_campaign=gmb&utm_id=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16088492694801707832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cold-stone-creamery",
      "poi_latitude": "35.3403621",
      "poi_longitude": "-80.7650158",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-548-9650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0da8-764a-9549-3665682ab112",
        "storage_key": "property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQVp0FQcVIgROHMfjd3ORd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "ec_99f65c2db3be48acc89f3aa5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "House Of Leng",
      "poi_type": "Restaurants",
      "poi_address": "2712 W Mallard Creek Church Rd #430, Charlotte, NC 28262, USA",
      "poi_short_description": "Chinese classics from egg rolls to noodle & rice dishes, served in a low-key, strip-mall space.",
      "poi_long_description": "Chinese classics from egg rolls to noodle & rice dishes, served in a low-key, strip-mall space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-16e5-707d-bd3d-008322fb2b6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-16e5-707d-bd3d-008322fb2b6a",
        "storage_key": "property/5653950229381120/019f1505-16e5-707d-bd3d-008322fb2b6a.webp",
        "width": 563,
        "height": 436
      },
      "poi_business_url": "http://houseofleng.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8652005508546213612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "house-of-leng",
      "poi_latitude": "35.3410699",
      "poi_longitude": "-80.7645337",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-510-5081",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0da8-764a-9549-3665682ab112",
        "storage_key": "property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeYPnI1UcVIgR7LaecysZEng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_65e5bf983dfd99884c2a360a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Giacomo's Pizzeria & Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "10230 Berkeley Pl Dr Ste 160, Charlotte, NC 28262, USA",
      "poi_short_description": "Casual, family-owned restaurant serving pizza, subs, pasta & other familiar Italian dishes.",
      "poi_long_description": "Casual, family-owned restaurant serving pizza, subs, pasta & other familiar Italian dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-17e8-762f-bc80-bbd7a65e3963.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-17e8-762f-bc80-bbd7a65e3963",
        "storage_key": "property/5653950229381120/019f1505-17e8-762f-bc80-bbd7a65e3963.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.giacomospizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=159206261602034233&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giacomos-pizzeria--italian-restaurant",
      "poi_latitude": "35.327191",
      "poi_longitude": "-80.738636",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 704-971-7313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0da8-764a-9549-3665682ab112",
        "storage_key": "property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAzhbJWkcVIgROaLOXECdNQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_eb19f0a5abe8ebf34d31290d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Hilltop Coffee",
      "poi_type": "Restaurants",
      "poi_address": "10227 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Relaxed cafe featuring a variety of coffee and tea beverages, along with baked items.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-1be1-71d4-805a-ebc79f6a5695.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-1be1-71d4-805a-ebc79f6a5695",
        "storage_key": "property/5653950229381120/019f1505-1be1-71d4-805a-ebc79f6a5695.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://hilltopcoffeeclt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16147778424382146218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hilltop-coffee",
      "poi_latitude": "35.3403242",
      "poi_longitude": "-80.7703255",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-323-5123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-61d7-713b-a2c0-6ec560b304f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-61d7-713b-a2c0-6ec560b304f4",
        "storage_key": "property/5653950229381120/019f1505-61d7-713b-a2c0-6ec560b304f4.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJC_urdowdVIgRqsYDIexuGOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_1ca19375452fb44fc945d46f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "8115 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-172a-735c-a286-14bc588fdd38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-172a-735c-a286-14bc588fdd38",
        "storage_key": "property/5653950229381120/019f1505-172a-735c-a286-14bc588fdd38.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/nc/charlotte/university-charlotte/5136?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:charlotte-nc-5136_pl:locurl_rd:1098",
      "poi_directions_map_url": "https://maps.google.com/?cid=3276598749556932542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "35.317532",
      "poi_longitude": "-80.77833299999999",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-921-5971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0da8-764a-9549-3665682ab112",
        "storage_key": "property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMYZt3MUdVIgRvn_U2jPReC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_67dc5f0852b65530c198f132",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Mallard Creek Cafe",
      "poi_type": "Restaurants",
      "poi_address": "8604 Cliff Cameron Dr #116, Charlotte, NC 28269, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15050768509552052623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-cafe",
      "poi_latitude": "35.3227213",
      "poi_longitude": "-80.7787653",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-510-0909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0da8-764a-9549-3665682ab112",
        "storage_key": "property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYwbZmscdVIgRj0l8kDcS39A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_55aa5e6355eab168a34f34d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Sofie’s Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "2005 E Arbors Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Casual, spacious eatery plating steaks and seafood alongside burgers and cocktails, with DJs and frequent live music.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-1cb0-769c-938b-3c074623a414.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-1cb0-769c-938b-3c074623a414",
        "storage_key": "property/5653950229381120/019f1505-1cb0-769c-938b-3c074623a414.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://sofiessteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1642087406066038091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sofies-steakhouse",
      "poi_latitude": "35.3368415",
      "poi_longitude": "-80.75595349999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 980-207-4994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0da8-764a-9549-3665682ab112",
        "storage_key": "property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDykH-fAdVIgRS3W1sMvdyRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_e70b23f56844c25caa649e70",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Jet's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "2712 W Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Counter-serve chain offering Detroit-style pizza with flavored crusts, plus wings & subs.",
      "poi_long_description": "Counter-serve chain offering Detroit-style pizza with flavored crusts, plus wings & subs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-2250-76ec-bf9f-d27b3c7694df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-2250-76ec-bf9f-d27b3c7694df",
        "storage_key": "property/5653950229381120/019f1505-2250-76ec-bf9f-d27b3c7694df.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.jetspizza.com/stores/north-carolina/charlotte-university-city/2712-w-mallard-creek-church-rd/?utm-source=GMB&utm_medium=Yext&utm_campaign=NC-010CORP&utm_content=Website",
      "poi_directions_map_url": "https://maps.google.com/?cid=7944154770083759364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jets-pizza",
      "poi_latitude": "35.3411036",
      "poi_longitude": "-80.7646153",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-595-1991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0da8-764a-9549-3665682ab112",
        "storage_key": "property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeYPnI1UcVIgRBEWRZ6xOP24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_c2a3757625d58c5b841b3ad4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Red Robin Gourmet Burgers and Brews",
      "poi_type": "Restaurants",
      "poi_address": "8304 Kenbrooke Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_long_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-2120-779d-8349-59576f9b29e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-2120-779d-8349-59576f9b29e5",
        "storage_key": "property/5653950229381120/019f1505-2120-779d-8349-59576f9b29e5.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.redrobin.com/locations/nc/charlotte/harris-blvd-421",
      "poi_directions_map_url": "https://maps.google.com/?cid=10166319662064027858&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-robin-gourmet-burgers-and-brews",
      "poi_latitude": "35.3167976",
      "poi_longitude": "-80.77171059999999",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-971-2060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0da8-764a-9549-3665682ab112",
        "storage_key": "property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOSnKrM4dVIgR0khlgt4FFo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_3c3c39dca29876dab0af2a92",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Ma'Luz Mexican Grill (Mi Pueblo)",
      "poi_type": "Restaurants",
      "poi_address": "7003 University City Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Local Mexican chain serving a lengthy menu of traditional dishes in a casual atmosphere.",
      "poi_long_description": "Local Mexican chain serving a lengthy menu of traditional dishes in a casual atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-247a-7455-92b7-46e03f999bd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-247a-7455-92b7-46e03f999bd1",
        "storage_key": "property/5653950229381120/019f1505-247a-7455-92b7-46e03f999bd1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.maluz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14428406570365807821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maluz-mexican-grill-mi-pueblo",
      "poi_latitude": "35.2913522",
      "poi_longitude": "-80.7651436",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-299-6107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0da8-764a-9549-3665682ab112",
        "storage_key": "property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrUEv0L8fVIgRzeyQrVT_O8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_d946933d45bf31e1f4fa81d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Lidl",
      "poi_type": "Shopping & Retail",
      "poi_address": "615 W Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Clean chain featuring baked goods, groceries, produce and snacks, plus occasional deals.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-21cf-765a-abfb-f9c2d6843f6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-21cf-765a-abfb-f9c2d6843f6d",
        "storage_key": "property/5653950229381120/019f1505-21cf-765a-abfb-f9c2d6843f6d.webp",
        "width": 1280,
        "height": 731
      },
      "poi_business_url": "https://www.lidl.com/stores/US01044",
      "poi_directions_map_url": "https://maps.google.com/?cid=4540294468895301395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lidl",
      "poi_latitude": "35.32765",
      "poi_longitude": "-80.73854999999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 888-654-3515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0dad-73bf-ad8b-284273b7ee09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0dad-73bf-ad8b-284273b7ee09",
        "storage_key": "property/5653950229381120/019f1503-0dad-73bf-ad8b-284273b7ee09.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY6j2oYYdVIgRE98sksNdAj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_06e2c2dba054b58533b44ce2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Harris Teeter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2720 W Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-22fb-77a4-8259-72d79b3e816d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-22fb-77a4-8259-72d79b3e816d",
        "storage_key": "property/5653950229381120/019f1505-22fb-77a4-8259-72d79b3e816d.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.harristeeter.com/stores/grocery/nc/charlotte/cochran-commons/097/00220?cid=loc_09700220_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2901704986130686064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harris-teeter",
      "poi_latitude": "35.3415072",
      "poi_longitude": "-80.7648766",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-717-7501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0dad-73bf-ad8b-284273b7ee09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0dad-73bf-ad8b-284273b7ee09",
        "storage_key": "property/5653950229381120/019f1503-0dad-73bf-ad8b-284273b7ee09.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-SchLFUcVIgRcKBMnU_tRCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_131d2aba66a640c84914219e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "2800 W Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-24ed-71a8-8303-7cec74fa0da5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-24ed-71a8-8303-7cec74fa0da5",
        "storage_key": "property/5653950229381120/019f1505-24ed-71a8-8303-7cec74fa0da5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2800+w+mallard+creek+church+rd-charlotte-nc-28262/id=6480",
      "poi_directions_map_url": "https://maps.google.com/?cid=10963065391076516784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.341578",
      "poi_longitude": "-80.7664626",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-549-1272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkcz93qodVIgRsKN-bOOhJJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_8ffc4ebbdba0e39033ebd40f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "10515 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-23a2-713f-b7c9-2c165024a25f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-23a2-713f-b7c9-2c165024a25f",
        "storage_key": "property/5653950229381120/019f1505-23a2-713f-b7c9-2c165024a25f.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/charlotte-nc-pharmacies/10515-mallard-creek-road-charlotte-nc-28262/storeid=2559?WT.mc_id=LS_GOOGLE_RX_2559",
      "poi_directions_map_url": "https://maps.google.com/?cid=12047423090634507296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.3424104",
      "poi_longitude": "-80.7676571",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-547-9739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-61d3-72d8-a485-bc8fb1931b92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-61d3-72d8-a485-bc8fb1931b92",
        "storage_key": "property/5653950229381120/019f1505-61d3-72d8-a485-bc8fb1931b92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_Q8k6odVIgRIMQbkHgLMac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d343c7825c0c44e78b2eaf83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "11530 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Clean supermarket with everyday groceries and a variety of products at low prices.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-254c-7708-988c-83f4b9f30339.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-254c-7708-988c-83f4b9f30339",
        "storage_key": "property/5653950229381120/019f1505-254c-7708-988c-83f4b9f30339.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/6233-charlotte-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1734489702722648400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "35.3341357",
      "poi_longitude": "-80.7125191",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-428-8134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0dad-73bf-ad8b-284273b7ee09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0dad-73bf-ad8b-284273b7ee09",
        "storage_key": "property/5653950229381120/019f1503-0dad-73bf-ad8b-284273b7ee09.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkym2fIMbVIgRUDlb5TElEhg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_02aadd12d21affdc3ce0a7d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Mallard Crossing Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "3020 Prosperity Church Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-27fc-750b-89f0-c1bb8994a1be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-27fc-750b-89f0-c1bb8994a1be",
        "storage_key": "property/5653950229381120/019f1505-27fc-750b-89f0-c1bb8994a1be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://mallard-center-charlotte.edan.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2378505321142158617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-crossing-shopping-center",
      "poi_latitude": "35.3431739",
      "poi_longitude": "-80.76942439999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR67PeqodVIgRGQUO2_wlAiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_88a94ca0ab3a9c463bee1c2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "8110 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-2b1d-7229-a407-3831cdac55f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-2b1d-7229-a407-3831cdac55f9",
        "storage_key": "property/5653950229381120/019f1505-2b1d-7229-a407-3831cdac55f9.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "https://locations.dollartree.com/nc/charlotte/8110-mallard-creek-road?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=15639077936987441231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "35.31759590000001",
      "poi_longitude": "-80.778928",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-501-0276",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e10-76be-80eb-dbca8122b364.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e10-76be-80eb-dbca8122b364",
        "storage_key": "property/5653950229381120/019f1503-0e10-76be-80eb-dbca8122b364.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhQI1vM0dVIgRTwjJOIYqCdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_73c265a08bfd2792ad8ff6f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "10409 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-26da-75ce-a325-1be92a7e8d30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-26da-75ce-a325-1be92a7e8d30",
        "storage_key": "property/5653950229381120/019f1505-26da-75ce-a325-1be92a7e8d30.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/charlotte/10409-mallard-creek-rd/2723940?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3572799963496001470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "35.3416329",
      "poi_longitude": "-80.76892219999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-548-9539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-61de-77c7-a3d1-ceefc5d3ebff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-61de-77c7-a3d1-ceefc5d3ebff",
        "storage_key": "property/5653950229381120/019f1505-61de-77c7-a3d1-ceefc5d3ebff.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJfQZIV6odVIgRvi-1JaMilTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_89468da0e4a567025ff5dd5b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Cochran Commons",
      "poi_type": "Shopping & Retail",
      "poi_address": "2700-2800 W Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Shopping center featuring Harris Teeter groceries, eateries, and personal services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-28bb-760b-97e6-eedff003fa1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-28bb-760b-97e6-eedff003fa1e",
        "storage_key": "property/5653950229381120/019f1505-28bb-760b-97e6-eedff003fa1e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regencycenters.com/property/detail/60314/Cochran-Commons",
      "poi_directions_map_url": "https://maps.google.com/?cid=12131066941942868027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cochran-commons",
      "poi_latitude": "35.3411944",
      "poi_longitude": "-80.76537139999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 919-831-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e10-76be-80eb-dbca8122b364.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e10-76be-80eb-dbca8122b364",
        "storage_key": "property/5653950229381120/019f1503-0e10-76be-80eb-dbca8122b364.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJkx1VK1UcVIgROyj9TBw1Wqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_f0f71ba274e105d3fed65294",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Mallard Crossing Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "3020 Prosperity Church Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-2b0b-749d-82ec-993e6683ac2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-2b0b-749d-82ec-993e6683ac2a",
        "storage_key": "property/5653950229381120/019f1505-2b0b-749d-82ec-993e6683ac2a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://mallard-center-charlotte.edan.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2378505321142158617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-crossing-shopping-center",
      "poi_latitude": "35.3431739",
      "poi_longitude": "-80.76942439999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR67PeqodVIgRGQUO2_wlAiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_af48290df8d02a3f7f28d0b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Mallard Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "9801 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-29fd-769f-998f-4b132c7a70dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-29fd-769f-998f-4b132c7a70dc",
        "storage_key": "property/5653950229381120/019f1505-29fd-769f-998f-4b132c7a70dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cmsk12.org/mallardcreekES",
      "poi_directions_map_url": "https://maps.google.com/?cid=9511436041936188988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-elementary-school",
      "poi_latitude": "35.3354412",
      "poi_longitude": "-80.7741362",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-343-3980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e10-76be-80eb-e3e0355a2e1a",
        "storage_key": "property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV3xM6uscVIgRPDZ0t69o_4M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_ffc3cd4d21d692b5b500a5cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Mallard Creek High School",
      "poi_type": "Education",
      "poi_address": "3825 Johnston Oehler Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-2a4b-72f9-b5dd-63b1bab8adea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-2a4b-72f9-b5dd-63b1bab8adea",
        "storage_key": "property/5653950229381120/019f1505-2a4b-72f9-b5dd-63b1bab8adea.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.cmsk12.org/mallardcreekHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=6531472597723805118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-high-school",
      "poi_latitude": "35.36517",
      "poi_longitude": "-80.76934159999999",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-343-1341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e10-76be-80eb-e3e0355a2e1a",
        "storage_key": "property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQx6peB8dVIgRvnWG77hzpFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_57086413711c568456ea094f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Ridge Road Middle School",
      "poi_type": "Education",
      "poi_address": "7260 Highland Creek Pkwy, Charlotte, NC 28269, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cmsk12.org/ridgeroadMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=1281427930266189462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridge-road-middle-school",
      "poi_latitude": "35.37623500000001",
      "poi_longitude": "-80.76235400000002",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-344-3410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e10-76be-80eb-e3e0355a2e1a",
        "storage_key": "property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO8lKEtccVIgRlr7HzOmLyBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_6e7f410d59153c2fba8e54ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Mallard Creek STEM Academy",
      "poi_type": "Education",
      "poi_address": "9142 Browne Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-2f5b-727d-8ed3-27ad9092c812.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-2f5b-727d-8ed3-27ad9092c812",
        "storage_key": "property/5653950229381120/019f1505-2f5b-727d-8ed3-27ad9092c812.webp",
        "width": 480,
        "height": 600
      },
      "poi_business_url": "https://mcstemacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1087305873682647216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-stem-academy",
      "poi_latitude": "35.3669731",
      "poi_longitude": "-80.7978491",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 980-288-4811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e10-76be-80eb-e3e0355a2e1a",
        "storage_key": "property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBwg_p2cdVIgRsMgMa-7iFg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_00a00c5190e26a91081181da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Chesterbrook Academy Preschool",
      "poi_type": "Education",
      "poi_address": "8515 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-30c4-7458-acdc-3d52fd290586.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-30c4-7458-acdc-3d52fd290586",
        "storage_key": "property/5653950229381120/019f1505-30c4-7458-acdc-3d52fd290586.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chesterbrookacademy.com/preschools/nc/charlotte/mallard-creek-rd/?utm_medium=directory&utm_source=gmb&utm_campaign=profile&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=17624814683415102748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesterbrook-academy-preschool",
      "poi_latitude": "35.3211353",
      "poi_longitude": "-80.77730079999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-624-8481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e10-76be-80eb-e3e0355a2e1a",
        "storage_key": "property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7zleL8gdVIgRHMULBZPrl_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_62bb43b523e761864722b90a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Bright Horizons at Mallard Creek",
      "poi_type": "Education",
      "poi_address": "9215 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-2fd8-7198-838d-ae3e0784e4fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-2fd8-7198-838d-ae3e0784e4fc",
        "storage_key": "property/5653950229381120/019f1505-2fd8-7198-838d-ae3e0784e4fc.webp",
        "width": 1152,
        "height": 768
      },
      "poi_business_url": "https://www.brighthorizons.com/daycare-centers/nc/charlotte/9215-mallard-creek-road-28262?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_term=weblink&utm_content=centerwebsite&IMS_SOURCE_SPECIFY=google%7Corganic%7Cgmb%7Cweblink%7Ccenterwebsite",
      "poi_directions_map_url": "https://maps.google.com/?cid=14988691535457380042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-horizons-at-mallard-creek",
      "poi_latitude": "35.3290795",
      "poi_longitude": "-80.7730973",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-227-0285",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e10-76be-80eb-e3e0355a2e1a",
        "storage_key": "property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMVpjLb0dVIgRymbXuomHAtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_a5675b513bcdf31d287af825",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "The Goddard School of Charlotte - Mallard Creek",
      "poi_type": "Education",
      "poi_address": "2545 Galloway Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Infant- through pre-K-aged child-care center focused on education.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-31c9-744f-88b6-1a9d48267f53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-31c9-744f-88b6-1a9d48267f53",
        "storage_key": "property/5653950229381120/019f1505-31c9-744f-88b6-1a9d48267f53.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.goddardschool.com/schools/nc/charlotte/charlotte-mallard-creek?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=10142839995434038419&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-charlotte---mallard-creek",
      "poi_latitude": "35.3440932",
      "poi_longitude": "-80.7618411",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-337-4888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e10-76be-80eb-e3e0355a2e1a",
        "storage_key": "property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHX99af8cVIgRk3R4nTybwow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_2f6831d58160cde0259e034a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "University of North Carolina at Charlotte",
      "poi_type": "Education",
      "poi_address": "9201 University City Blvd, Charlotte, NC 28223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1502-bffa-7578-9f59-738cf1825ad3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-bffa-7578-9f59-738cf1825ad3",
        "storage_key": "property/5653950229381120/019f1502-bffa-7578-9f59-738cf1825ad3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.charlotte.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728009800198595827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-carolina-at-charlotte",
      "poi_latitude": "35.3074169",
      "poi_longitude": "-80.73521219999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-687-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e10-76be-80eb-e3e0355a2e1a",
        "storage_key": "property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyOp0BocVIgR8yST8fdnP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_460e01d388b339ffa3f13882",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Central Piedmont Community College - Levine Campus",
      "poi_type": "Education",
      "poi_address": "2800 Campus Ridge Rd Suite 1113, Matthews, NC 28105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-3939-760f-b4b7-781cfa6c5e69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-3939-760f-b4b7-781cfa6c5e69",
        "storage_key": "property/5653950229381120/019f1505-3939-760f-b4b7-781cfa6c5e69.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cpcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10540439868142705401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-piedmont-community-college---levine-campus",
      "poi_latitude": "35.1061053",
      "poi_longitude": "-80.69308509999999",
      "poi_miles_from_property": "20.3 mi",
      "poi_walking_minutes": "7 hours 30 mins",
      "poi_biking_minutes": "1 hour 55 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 704-330-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e10-76be-80eb-e3e0355a2e1a",
        "storage_key": "property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCSbwKmwkVIgR-doC5TYqR5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_1cba00f889df4fb5850379c9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Truliant Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "707 Pavilion Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Sprawling outdoor venue for a variety of musical acts, from country to R&B, plus festivals & events.",
      "poi_long_description": "Sprawling outdoor venue for a variety of musical acts, from country to R&B, plus festivals & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-33a8-74ed-9130-575fd6395b2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-33a8-74ed-9130-575fd6395b2e",
        "storage_key": "property/5653950229381120/019f1505-33a8-74ed-9130-575fd6395b2e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.truliantamp.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8876681391951831978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "truliant-amphitheater",
      "poi_latitude": "35.3271592",
      "poi_longitude": "-80.7123113",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-549-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC2hDco8bVIgRquOb_7FOMHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "ec_1c81cd94b17a676d71124f71",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Skyla Credit Union Amphitheatre",
      "poi_type": "Entertainment",
      "poi_address": "1000 Nc Music Factory Blvd, Charlotte, NC 28206, USA",
      "poi_short_description": "Outdoor performance space staging concerts & shows, with lawn seating & views of the skyline.",
      "poi_long_description": "Outdoor performance space staging concerts & shows, with lawn seating & views of the skyline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-3565-730c-913a-da30d84ef1eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-3565-730c-913a-da30d84ef1eb",
        "storage_key": "property/5653950229381120/019f1505-3565-730c-913a-da30d84ef1eb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.skylacuamp.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=373075008026769190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skyla-credit-union-amphitheatre",
      "poi_latitude": "35.23964",
      "poi_longitude": "-80.8445527",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 980-495-0550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPWL3zzegVogRJvcCQL5tLQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "ec_0941adc39bcfcf7622e71ba1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "AvidXchange Music Factory",
      "poi_type": "Entertainment",
      "poi_address": "1000 Nc Music Factory Blvd, Charlotte, NC 28206, USA",
      "poi_short_description": "Large leisure and dining complex with a beer garden, multiple restaurants, comedy clubs and concert venues.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-36d8-75be-a941-4206a11aec8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-36d8-75be-a941-4206a11aec8c",
        "storage_key": "property/5653950229381120/019f1505-36d8-75be-a941-4206a11aec8c.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.avidxchangemusicfactory.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15900751944736699666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "avidxchange-music-factory",
      "poi_latitude": "35.2401967",
      "poi_longitude": "-80.84582019999999",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-916-8970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPWL3zzegVogREvWh36XRqtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_0ed71e83910d5e6b17f4b535",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Topgolf Charlotte - University",
      "poi_type": "Entertainment",
      "poi_address": "9110 Drivers Wy, Charlotte, NC 28262, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1502-b75e-729d-87f3-6033cec6eb90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-b75e-729d-87f3-6033cec6eb90",
        "storage_key": "property/5653950229381120/019f1502-b75e-729d-87f3-6033cec6eb90.webp",
        "width": 1280,
        "height": 733
      },
      "poi_business_url": "https://topgolf.com/us/charlotte-university/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14916876276335703365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-charlotte---university",
      "poi_latitude": "35.2875467",
      "poi_longitude": "-80.7702764",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-701-0450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0da8-764a-9549-3665682ab112",
        "storage_key": "property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiWWWOZUfVIgRRfVwufBjA88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_64497d7fd7a0ed0dcdb1a114",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "UNC Charlotte Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "9090 Craver Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_long_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1502-f888-734a-93a2-660b60659226.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-f888-734a-93a2-660b60659226",
        "storage_key": "property/5653950229381120/019f1502-f888-734a-93a2-660b60659226.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://gardens.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4177973296962421892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-charlotte-botanical-gardens",
      "poi_latitude": "35.3078198",
      "poi_longitude": "-80.72969499999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-687-0721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6cM9xocVIgRhESD5pMk-zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_3fff49e6f9768c659bc8266a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Armored Cow Brewing Co.",
      "poi_type": "Entertainment",
      "poi_address": "8821 JW Clay Blvd #1, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-4f20-7326-96db-51baedd7c9d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-4f20-7326-96db-51baedd7c9d7",
        "storage_key": "property/5653950229381120/019f1505-4f20-7326-96db-51baedd7c9d7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.armoredcowbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17284853622865960872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "armored-cow-brewing-co",
      "poi_latitude": "35.3135477",
      "poi_longitude": "-80.7532232",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-277-6641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-UL_z-YdVIgRqJ-Mecoi4O8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_59d4a07cc8668131abbeafb4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Flying Saucer Draught Emporium",
      "poi_type": "Entertainment",
      "poi_address": "9605 N Tryon St A, Charlotte, NC 28262, USA",
      "poi_short_description": "Chain taproom offering 200+ global beers & pub fare in tavernlike surroundings.",
      "poi_long_description": "Chain taproom offering 200+ global beers & pub fare in tavernlike surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-35fa-74da-83fd-688c18162695.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-35fa-74da-83fd-688c18162695",
        "storage_key": "property/5653950229381120/019f1505-35fa-74da-83fd-688c18162695.webp",
        "width": 1150,
        "height": 350
      },
      "poi_business_url": "http://www.beerknurd.com/locations/charlotte-flying-saucer",
      "poi_directions_map_url": "https://maps.google.com/?cid=2114554646901837938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flying-saucer-draught-emporium",
      "poi_latitude": "35.3167182",
      "poi_longitude": "-80.74052669999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-717-8179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0da8-764a-9549-3665682ab112",
        "storage_key": "property/5653950229381120/019f1503-0da8-764a-9549-3665682ab112.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-XTUxQcVIgRclC8ej9oWB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_8a78ac2dd8854db049fa0a8d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "AMC Northlake 14",
      "poi_type": "Entertainment",
      "poi_address": "7325 Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Comfortable theater featuring reclining seats, clean toilets and kind staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-3861-7567-b595-09174d091af7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-3861-7567-b595-09174d091af7",
        "storage_key": "property/5653950229381120/019f1505-3861-7567-b595-09174d091af7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/charlotte/amc-northlake-14?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11641706098324670943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-northlake-14",
      "poi_latitude": "35.353584",
      "poi_longitude": "-80.850346",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-596-2137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-61d6-7132-97de-a635039d2405.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-61d6-7132-97de-a635039d2405",
        "storage_key": "property/5653950229381120/019f1505-61d6-7132-97de-a635039d2405.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJb55buKunVogR3wkkGgSmj6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_cf73743c691fb0dce33e8c73",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Reedy Creek Nature Preserve",
      "poi_type": "Entertainment",
      "poi_address": "2900 Rocky River Rd, Charlotte, NC 28215, USA",
      "poi_short_description": "Creekside walks & fishing spots in woodland with picnic shelters & ruins of pioneer-era cabins.",
      "poi_long_description": "Creekside walks & fishing spots in woodland with picnic shelters & ruins of pioneer-era cabins.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1502-ea90-76f4-ac26-b21c1bb4c6be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-ea90-76f4-ac26-b21c1bb4c6be",
        "storage_key": "property/5653950229381120/019f1502-ea90-76f4-ac26-b21c1bb4c6be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Places-to-Visit/Nature/reedy-creek-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=4056376883772919066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reedy-creek-nature-preserve",
      "poi_latitude": "35.26378750000001",
      "poi_longitude": "-80.71209840000002",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 980-314-1119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e0f-758d-b0bd-95fec3b1d68a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e0f-758d-b0bd-95fec3b1d68a",
        "storage_key": "property/5653950229381120/019f1503-0e0f-758d-b0bd-95fec3b1d68a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYzQOkoZVIgRGg1kwEglSzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_308b766af1358966c1208a71",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Popp-Martin Student Union",
      "poi_type": "Entertainment",
      "poi_address": "8845 Craver Rd, Charlotte, NC 28223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-3a02-72f9-8f4e-9e02a9085a4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-3a02-72f9-8f4e-9e02a9085a4a",
        "storage_key": "property/5653950229381120/019f1505-3a02-72f9-8f4e-9e02a9085a4a.webp",
        "width": 1280,
        "height": 691
      },
      "poi_business_url": "https://studentunion.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17396722810051266190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "popp-martin-student-union",
      "poi_latitude": "35.3085879",
      "poi_longitude": "-80.73373749999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-687-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgwH7oBocVIgRjoYKVTmTbfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_d72c566a60088e93d8de0dc7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Atrium Health University City",
      "poi_type": "Health and Wellness",
      "poi_address": "8800 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1502-e256-776b-8f85-7ec68862438c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-e256-776b-8f85-7ec68862438c",
        "storage_key": "property/5653950229381120/019f1502-e256-776b-8f85-7ec68862438c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-university-city?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=7076796399763319050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-university-city",
      "poi_latitude": "35.3066306",
      "poi_longitude": "-80.7472512",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-863-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0d8b-7098-b52c-5034a7bc8065.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0d8b-7098-b52c-5034a7bc8065",
        "storage_key": "property/5653950229381120/019f1503-0d8b-7098-b52c-5034a7bc8065.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpeG8ryMcVIgRCumnw9TUNWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_20e31e70d158f5e7083acb7b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "FastMed Urgent Care Charlotte Mallard Creek",
      "poi_type": "Health and Wellness",
      "poi_address": "2728 W Mallard Creek Church Rd Ste 300, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-3bf0-77fe-8e14-40b7fa563663.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-3bf0-77fe-8e14-40b7fa563663",
        "storage_key": "property/5653950229381120/019f1505-3bf0-77fe-8e14-40b7fa563663.webp",
        "width": 904,
        "height": 609
      },
      "poi_business_url": "https://www.fastmed.com/urgent-care-centers/charlotte-nc-walk-in-clinic-west-mallard-creek-church-road",
      "poi_directions_map_url": "https://maps.google.com/?cid=12204928611885799257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fastmed-urgent-care-charlotte-mallard-creek",
      "poi_latitude": "35.3417425",
      "poi_longitude": "-80.7655249",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 980-218-1860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhe1vMVUcVIgRWVd0dOidYKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_fbb3e995101223e057b1eb5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2800 W Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-3de2-757d-aa4d-107adf9cc2da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-3de2-757d-aa4d-107adf9cc2da",
        "storage_key": "property/5653950229381120/019f1505-3de2-757d-aa4d-107adf9cc2da.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2800+w+mallard+creek+church+rd-charlotte-nc-28262/id=6480",
      "poi_directions_map_url": "https://maps.google.com/?cid=7354565032060315453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "35.3413989",
      "poi_longitude": "-80.76639329999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-549-1272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-61d3-72d8-a485-bc8fb1931b92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-61d3-72d8-a485-bc8fb1931b92",
        "storage_key": "property/5653950229381120/019f1505-61d3-72d8-a485-bc8fb1931b92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK2fQ0aodVIgRPed2Ne6pEGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_3db20ebf4ed8421b2087367a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "10515 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-23a2-713f-b7c9-2c165024a25f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-23a2-713f-b7c9-2c165024a25f",
        "storage_key": "property/5653950229381120/019f1505-23a2-713f-b7c9-2c165024a25f.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/charlotte-nc-pharmacies/10515-mallard-creek-road-charlotte-nc-28262/storeid=2559?WT.mc_id=LS_GOOGLE_RX_2559",
      "poi_directions_map_url": "https://maps.google.com/?cid=12047423090634507296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.3424104",
      "poi_longitude": "-80.7676571",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-547-9739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-61d3-72d8-a485-bc8fb1931b92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-61d3-72d8-a485-bc8fb1931b92",
        "storage_key": "property/5653950229381120/019f1505-61d3-72d8-a485-bc8fb1931b92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_Q8k6odVIgRIMQbkHgLMac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_740ef84e8f7eaf83e1f3650c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10215 University City Blvd B, Charlotte, NC 28213, USA",
      "poi_short_description": "Chain gym featuring a variety of equipment, tanning beds, and 24-hour access.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1502-d136-720f-bd34-338c7a09e487.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-d136-720f-bd34-338c7a09e487",
        "storage_key": "property/5653950229381120/019f1502-d136-720f-bd34-338c7a09e487.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/charlotte-university-blvd-nc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=15550441792175585086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.31210069999999",
      "poi_longitude": "-80.713909",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-548-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYakZvEbVIgRPrcDk2tEztc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_04a7c8ac26ebdedf8bdf3ec0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Fitness Connection",
      "poi_type": "Health and Wellness",
      "poi_address": "8709 JW Clay Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Chain gym featuring cardio and strength equipment, basketball courts, and a Kids' Club.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1502-d446-72cb-8d57-8cb5f243a034.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-d446-72cb-8d57-8cb5f243a034",
        "storage_key": "property/5653950229381120/019f1502-d446-72cb-8d57-8cb5f243a034.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "https://fitnessconnection.com/gyms/university/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15703214807914536897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitness-connection",
      "poi_latitude": "35.3113238",
      "poi_longitude": "-80.7552175",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-405-1330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRQH-yYcVIgRwV9mKasG7dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_b1375feab310914260029c2e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Crunch Fitness - Charlotte University",
      "poi_type": "Health and Wellness",
      "poi_address": "8514 University City Blvd, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1502-cf3c-722f-9b52-c287b76cb3f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-cf3c-722f-9b52-c287b76cb3f5",
        "storage_key": "property/5653950229381120/019f1502-cf3c-722f-9b52-c287b76cb3f5.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.crunch.com/locations/charlotte-university",
      "poi_directions_map_url": "https://maps.google.com/?cid=14303347583871890250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---charlotte-university",
      "poi_latitude": "35.2955331",
      "poi_longitude": "-80.74004959999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-440-9391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJacytSIUfVIgRSjOgW9iyf8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_b0c071ab95861d049bd7bee0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "9Round Kickboxing",
      "poi_type": "Health and Wellness",
      "poi_address": "2115 E Arbors Dr #160, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-3e91-76e8-bca8-0a33274668bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-3e91-76e8-bca8-0a33274668bf",
        "storage_key": "property/5653950229381120/019f1505-3e91-76e8-bca8-0a33274668bf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.9round.com/CharlotteUniversity",
      "poi_directions_map_url": "https://maps.google.com/?cid=15265661663952487491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "9round-kickboxing",
      "poi_latitude": "35.33741",
      "poi_longitude": "-80.75702",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 980-224-8512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdfqT1FAcVIgRQ8QvBWeG2tM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_a8d0a9b2d853da059df432f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Mallard Creek Recreation Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2530 Johnston Oehler Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Recreation center with a gym, multipurpose rooms, and a nature trail, plus parking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-4225-7358-9262-33e80a3bef5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-4225-7358-9262-33e80a3bef5a",
        "storage_key": "property/5653950229381120/019f1505-4225-7358-9262-33e80a3bef5a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/places-to-visit/rec-centers/mallard-creek-recreation-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=944166955806814435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-recreation-center",
      "poi_latitude": "35.3570067",
      "poi_longitude": "-80.759945",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-314-1121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvcZ6fOQcVIgR4_CGCdhaGg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_cbcd879cf270722b0768bec5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Mallard Creek Greenway - East Terminus",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 E Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-41c0-77cb-ac06-3f30f2737915.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-41c0-77cb-ac06-3f30f2737915",
        "storage_key": "property/5653950229381120/019f1505-41c0-77cb-ac06-3f30f2737915.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mecknc.gov/ParkandRec/Greenways/OpenGreenways/Pages/MallardCreekandClark'sCreek.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15209037215157520469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-greenway---east-terminus",
      "poi_latitude": "35.32064940000001",
      "poi_longitude": "-80.73165089999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUaiP2cwdVIgRVQgpKcRaEdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_307c17f456ba735f951e127e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Clarks Creek Greenway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9729 Mallard Creek Rd, Charlotte, NC 28267, USA",
      "poi_short_description": "This 7-mile trail with a wooded creekside setting attracts bikers, runners & skateboarders.",
      "poi_long_description": "This 7-mile trail with a wooded creekside setting attracts bikers, runners & skateboarders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-43c9-7101-a38c-9bb39c3e13d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-43c9-7101-a38c-9bb39c3e13d4",
        "storage_key": "property/5653950229381120/019f1505-43c9-7101-a38c-9bb39c3e13d4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14285017145315421591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clarks-creek-greenway",
      "poi_latitude": "35.3345362",
      "poi_longitude": "-80.7740029",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEWo_U0gcVIgRl-3jjGiTPsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_9002c6cab266bf3e10382fbc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Mallard Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3001 Johnston Oehler Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Recreation area featuring 8 soccer fields, a batting cage, and 2 playgrounds, plus a volleyball court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-4478-7129-8e5d-92d88d203d85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-4478-7129-8e5d-92d88d203d85",
        "storage_key": "property/5653950229381120/019f1505-4478-7129-8e5d-92d88d203d85.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=412983690555762575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-park",
      "poi_latitude": "35.3614698",
      "poi_longitude": "-80.7624001",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e0f-758d-b0bd-95fec3b1d68a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e0f-758d-b0bd-95fec3b1d68a",
        "storage_key": "property/5653950229381120/019f1503-0e0f-758d-b0bd-95fec3b1d68a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB6J0seEcVIgRjyebfXo2uwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2d7c150cfc7ae301c5e54464",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Mallard Creek Recreation Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2530 Johnston Oehler Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Recreation center with a gym, multipurpose rooms, and a nature trail, plus parking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-46ee-741e-af8f-1d006c568e22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-46ee-741e-af8f-1d006c568e22",
        "storage_key": "property/5653950229381120/019f1505-46ee-741e-af8f-1d006c568e22.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/places-to-visit/rec-centers/mallard-creek-recreation-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=944166955806814435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-recreation-center",
      "poi_latitude": "35.3570067",
      "poi_longitude": "-80.759945",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-314-1121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvcZ6fOQcVIgR4_CGCdhaGg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_13c660bfe4bd1df66a25d6c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Kirk Farm Fields",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 E Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Park featuring a free-admission soccer field, plus a trail popular with walkers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-4fce-775c-b12d-28ba8689c2e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-4fce-775c-b12d-28ba8689c2e0",
        "storage_key": "property/5653950229381120/019f1505-4fce-775c-b12d-28ba8689c2e0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11021419022114840190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kirk-farm-fields",
      "poi_latitude": "35.32097",
      "poi_longitude": "-80.73192999999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-336-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE3H3n3IcVIgRfl7j5TTy85g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "ec_eb358b6dfecfa441fbc9e6fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Clarks Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5435 Hucks Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Family-friendly park equipped with picnic tables, swing sets, playgrounds, basketball courts, splash pads and tennis courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-4a63-723d-9f24-75d22fa70478.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-4a63-723d-9f24-75d22fa70478",
        "storage_key": "property/5653950229381120/019f1505-4a63-723d-9f24-75d22fa70478.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16436839230062349110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clarks-creek-park",
      "poi_latitude": "35.3541742",
      "poi_longitude": "-80.808039",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e0f-758d-b0bd-95fec3b1d68a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e0f-758d-b0bd-95fec3b1d68a",
        "storage_key": "property/5653950229381120/019f1503-0e0f-758d-b0bd-95fec3b1d68a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6y6TghinVogRNksSkjFiG-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d7aedb2e41ed41c73f31e19b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Clarks Creek Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5542 Hucks Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Nature preserve featuring trails and a playground, plus basketball and tennis courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-4ad1-7328-b1cf-e8a4258fe475.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-4ad1-7328-b1cf-e8a4258fe475",
        "storage_key": "property/5653950229381120/019f1505-4ad1-7328-b1cf-e8a4258fe475.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Places-to-Visit/Nature",
      "poi_directions_map_url": "https://maps.google.com/?cid=1118185895994378143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clarks-creek-nature-preserve",
      "poi_latitude": "35.3522197",
      "poi_longitude": "-80.8102792",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e0f-758d-b0bd-95fec3b1d68a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e0f-758d-b0bd-95fec3b1d68a",
        "storage_key": "property/5653950229381120/019f1503-0e0f-758d-b0bd-95fec3b1d68a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf6LFuoCnVogRn8eY4yWYhA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_c21f65cea31e684feeb6c9b6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "UNC Charlotte Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9090 Craver Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_long_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1502-f888-734a-93a2-660b60659226.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-f888-734a-93a2-660b60659226",
        "storage_key": "property/5653950229381120/019f1502-f888-734a-93a2-660b60659226.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://gardens.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4177973296962421892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-charlotte-botanical-gardens",
      "poi_latitude": "35.3078198",
      "poi_longitude": "-80.72969499999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-687-0721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6cM9xocVIgRhESD5pMk-zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_f812c3b701437455eb953c1f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Toby Creek Greenway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "805 Rocky River Rd W, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-4d7e-7104-b000-04c09a8321eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-4d7e-7104-b000-04c09a8321eb",
        "storage_key": "property/5653950229381120/019f1505-4d7e-7104-b000-04c09a8321eb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Places-to-Visit/greenways",
      "poi_directions_map_url": "https://maps.google.com/?cid=503254549599039572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toby-creek-greenway",
      "poi_latitude": "35.2855733",
      "poi_longitude": "-80.7483759",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e0f-758d-b0bd-95fec3b1d68a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e0f-758d-b0bd-95fec3b1d68a",
        "storage_key": "property/5653950229381120/019f1503-0e0f-758d-b0bd-95fec3b1d68a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJE6hIC9IfVIgRVDBztFjr-wY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_eef8a3ee177831470d354529",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "JW Clay Blvd / UNC Charlotte",
      "poi_type": "Transportation & Transit",
      "poi_address": "9234-9300 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-53cd-708c-b1c9-18eadd8e2467.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-53cd-708c-b1c9-18eadd8e2467",
        "storage_key": "property/5653950229381120/019f1505-53cd-708c-b1c9-18eadd8e2467.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.charlottenc.gov/CATS/Rail/LYNX-Stations-and-Park-and-Rides/JW-Clay-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=9941066239111075827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jw-clay-blvd--unc-charlotte",
      "poi_latitude": "35.3108328",
      "poi_longitude": "-80.7450265",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wiIej0cVIgR8xfYDhPD9Yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_b3c86517ffdb3f60df06fb3e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "UNC Charlotte Main Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "9025 Cameron Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1502-f780-7089-86a7-a38f7bf693aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-f780-7089-86a7-a38f7bf693aa",
        "storage_key": "property/5653950229381120/019f1502-f780-7089-86a7-a38f7bf693aa.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "http://charlottenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=11588625435149076740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-charlotte-main-station",
      "poi_latitude": "35.3121822",
      "poi_longitude": "-80.73371980000002",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDTHpFBEcVIgRBAkeIW8R06A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_d8d01209ce5d7fa409257585",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "University City Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "7205 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1502-ff30-7103-b1d7-ffc3f2c9a78a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-ff30-7103-b1d7-ffc3f2c9a78a",
        "storage_key": "property/5653950229381120/019f1502-ff30-7103-b1d7-ffc3f2c9a78a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://charlonbvcsattenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=12467337922677263454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-city-blvd",
      "poi_latitude": "35.2869215",
      "poi_longitude": "-80.76073650000001",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZz4QjIUeVIgRXkzvL8nhBK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_f619b0792418c84638a30ed0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Mallard Creek Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2158274625695479655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-park--ride",
      "poi_latitude": "35.32323",
      "poi_longitude": "-80.77292",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcW0-QLYdVIgRZ3dRSFa78x0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_9058fbd61eff5ee717d84d87",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Northlake Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11574504833305702147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northlake-mall-park--ride",
      "poi_latitude": "35.352833",
      "poi_longitude": "-80.85521899999999",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVfdxJlWmVogRA286UNLmoKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_734c8011c802936dc433ce66",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-5485-72cc-9c0b-96c2ba21c72a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-5485-72cc-9c0b-96c2ba21c72a",
        "storage_key": "property/5653950229381120/019f1505-5485-72cc-9c0b-96c2ba21c72a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "19.1 mi",
      "poi_walking_minutes": "7 hours 4 mins",
      "poi_biking_minutes": "1 hour 54 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-1066-76aa-8e5e-daff056f2ede.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-1066-76aa-8e5e-daff056f2ede",
        "storage_key": "property/5653950229381120/019f1503-1066-76aa-8e5e-daff056f2ede.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_51ddf1f149fdf216733c966d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Charlotte Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-522a-748d-a804-a300addc6e1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-522a-748d-a804-a300addc6e1d",
        "storage_key": "property/5653950229381120/019f1505-522a-748d-a804-a300addc6e1d.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://www.ridetransit.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7843406414498383660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-transportation-center",
      "poi_latitude": "35.2243513",
      "poi_longitude": "-80.8413051",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-61d8-75bd-8896-945a56c28cd6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-61d8-75bd-8896-945a56c28cd6",
        "storage_key": "property/5653950229381120/019f1505-61d8-75bd-8896-945a56c28cd6.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ6xY9CWgVogRLEcy7ZNg2Ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_9284b034a7d4a8a61d83dc7a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "University of North Carolina at Charlotte",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9201 University City Blvd, Charlotte, NC 28223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1502-bffa-7578-9f59-738cf1825ad3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-bffa-7578-9f59-738cf1825ad3",
        "storage_key": "property/5653950229381120/019f1502-bffa-7578-9f59-738cf1825ad3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.charlotte.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728009800198595827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-carolina-at-charlotte",
      "poi_latitude": "35.3074169",
      "poi_longitude": "-80.73521219999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-687-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0e10-76be-80eb-e3e0355a2e1a",
        "storage_key": "property/5653950229381120/019f1503-0e10-76be-80eb-e3e0355a2e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyOp0BocVIgR8yST8fdnP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_79766a72d16c886d6decee6e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Vanguard Horizon Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1030 Admiral Nelson Ct, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-02d3-74de-9fef-c188313a0ed7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-02d3-74de-9fef-c188313a0ed7",
        "storage_key": "property/5653950229381120/019f1503-02d3-74de-9fef-c188313a0ed7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=838082317584164488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vanguard-horizon-building",
      "poi_latitude": "35.3271286",
      "poi_longitude": "-80.7640249",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe2eGJwAdVIgRiOYjcG13oQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_cb38170accd6b25ef7d8af23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Atrium Health University City",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8800 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1502-e256-776b-8f85-7ec68862438c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-e256-776b-8f85-7ec68862438c",
        "storage_key": "property/5653950229381120/019f1502-e256-776b-8f85-7ec68862438c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-university-city?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=7076796399763319050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-university-city",
      "poi_latitude": "35.3066306",
      "poi_longitude": "-80.7472512",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-863-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0d8b-7098-b52c-5034a7bc8065.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0d8b-7098-b52c-5034a7bc8065",
        "storage_key": "property/5653950229381120/019f1503-0d8b-7098-b52c-5034a7bc8065.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpeG8ryMcVIgRCumnw9TUNWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_a0ff0422993953c27395a4d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "IBM",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10925 David Taylor Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-54f1-702d-aa30-dc14172c0638.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-54f1-702d-aa30-dc14172c0638",
        "storage_key": "property/5653950229381120/019f1505-54f1-702d-aa30-dc14172c0638.webp",
        "width": 1200,
        "height": 720
      },
      "poi_business_url": "http://www.ibm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18312348945756321416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ibm",
      "poi_latitude": "35.3397408",
      "poi_longitude": "-80.76665109999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 800-426-4968",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJga6ZeVIcVIgRiPbN2leIIv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_245215a2457da7491f798727",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Novant Health University Family Physicians",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10810 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-59a6-763d-bf44-7ce258d7ca28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-59a6-763d-bf44-7ce258d7ca28",
        "storage_key": "property/5653950229381120/019f1505-59a6-763d-bf44-7ce258d7ca28.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.novanthealth.org/locations/clinics/university-family-physicians/?utm_source=maps.google.com&utm_medium=organic&utm_campaign=GBP&utm_content=MG-398",
      "poi_directions_map_url": "https://maps.google.com/?cid=6916733605554640047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "novant-health-university-family-physicians",
      "poi_latitude": "35.3432501",
      "poi_longitude": "-80.763071",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-510-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkyQ0gFUcVIgRr1QXXZEs_V8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_270499219469baa7efb25b75",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "University Research Professional Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9711 David Taylor Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-58e4-748f-9a2b-14b74bb0724c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-58e4-748f-9a2b-14b74bb0724c",
        "storage_key": "property/5653950229381120/019f1505-58e4-748f-9a2b-14b74bb0724c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10706431042047347261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-research-professional-building",
      "poi_latitude": "35.3258831",
      "poi_longitude": "-80.75712469999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJad0c2kgcVIgRPYpywU7ilJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_9f1f3b54454d6600e4cf1251",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "David Taylor corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10101 David Taylor Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-59f6-7729-be54-76430c73f521.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-59f6-7729-be54-76430c73f521",
        "storage_key": "property/5653950229381120/019f1505-59f6-7729-be54-76430c73f521.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13125167856831097102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "david-taylor-corporate",
      "poi_latitude": "35.3291109",
      "poi_longitude": "-80.7646894",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGTGairUdVIgRDunKK6D2JbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_eadbf2672d9233168d3f6df9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "10130 Mallard Creek Rd",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Mallard Creek Rd 10130 #300, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cpifinancial.com/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=289709524322393688",
      "poi_directions_map_url": "https://maps.google.com/?cid=12575079596839489910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "10130-mallard-creek-rd",
      "poi_latitude": "35.3388195",
      "poi_longitude": "-80.7695464",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-248-2704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKyToLIUdVIgRdlHhh0Sog64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "ec_992bdf6a922c1d02da7e09e7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "Vulcan Materials Co",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11020 David Taylor Dr #105, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.vulcanmaterials.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3121428326093051553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vulcan-materials-co",
      "poi_latitude": "35.339792",
      "poi_longitude": "-80.763125",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 205-298-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA5xO9lQcVIgRoVaeSIaKUSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_87275c096b9c3802b6a34e86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "poi_name": "University Research Professional Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9711 David Taylor Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1505-59f3-7360-8575-5dfaecb35c2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-59f3-7360-8575-5dfaecb35c2c",
        "storage_key": "property/5653950229381120/019f1505-59f3-7360-8575-5dfaecb35c2c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10706431042047347261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-research-professional-building",
      "poi_latitude": "35.3258831",
      "poi_longitude": "-80.75712469999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0db9-748e-a50b-f36cdaf1dbdb",
        "storage_key": "property/5653950229381120/019f1503-0db9-748e-a50b-f36cdaf1dbdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJad0c2kgcVIgRPYpywU7ilJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    }
  ],
  "office_hours": [
    {
      "id": "custom_052445fb-e89f-42b9-a6ba-ae93be2d2519",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0813039f-006f-4679-82de-1e74e44518e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_da4cd940-9f0c-416f-b9b7-c9f3110e8b4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f2f10685-27f5-43db-bbd7-8861485b7d04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_3d855289-2258-47bc-9c49-8e173debae2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_cf6fc0fd-ff22-4827-b551-94db409898c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_65b1db2d-b515-43e7-8df0-8c4b61c26f67",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "rating": "5.0",
      "name": "Jessica Brown",
      "text": "This is my first week here in my new apartment. I love it so far. Honeylet was the best ever. She worked with me almost daily to get me into my apartment and she was so patient with me. She checked in with me throughout the entire process and made sure I had everything I wanted and needed. The staff are all friendly and helpful but Honeylet definitely knows what she’s doing and she’s on point with everything. Thanks Honeylet for everything!",
      "date": "2026-02-28",
      "title": ""
    },
    {
      "id": "custom_ce69fcf5-72a8-4496-971f-344c9e546fe7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "rating": "5.0",
      "name": "Jayachand Thullimilli",
      "text": "My AC had a very complex issue, and the team worked incredibly hard to get it fixed. They spent multiple days diagnosing and troubleshooting the problem, showing total commitment to getting the job done right rather than rushing through it. Their persistence, professionalism, and dedication were outstanding. My system is now running perfectly. They provided a portable AC unit to keep you cool during the process.",
      "date": "2026-05-29",
      "title": ""
    },
    {
      "id": "custom_79c96332-34e4-4ec8-ac56-2533e25e4086",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "rating": "5.0",
      "name": "Smith",
      "text": "I had a great experience touring, applying, and moving in, with a special thanks to Ms. Honey. She was truly my guardian angel during a very difficult time when I needed to move quickly under tight deadlines. She was kind, responsive, and made the entire process so much less stressful.\nThe property is clean and well maintained, and my apartment was clean and comfortable at move in. The entire process was fast, smooth, and handled efficiently.\nI am very grateful for Ms. Honey’s support and professionalism. She really made all the difference. Highly recommend!",
      "date": "2026-03-17",
      "title": ""
    },
    {
      "id": "custom_aeafff8d-699a-493d-932b-d657c8ae1ab3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "rating": "5.0",
      "name": "Michael Small",
      "text": "We had a truly seamless experience moving into our new apartment, and I cannot say enough good things about the team that made it happen.\n\nFrom the very beginning, Honey, our leasing agent, was both professional and relational. She was attentive, communicative, and made sure we felt supported every step of the way. Moving can be stressful, but she made the entire process feel smooth, organized, and even enjoyable. You can tell she genuinely cares about the residents she works with.\n\nWe are really enjoying the layout of our new apartment. The space is comfortable, well-designed, and already feels like home. It is clear that a lot of thought went into making the units both functional and inviting.\n\nOne thing that stood out immediately was how responsive the maintenance team is. Derek got right to our repair requests with no questions asked and handled everything quickly and efficiently. That level of responsiveness gave us a lot of confidence and peace of mind early on.\n\nOn move-in day, JB provided exceptional service. He was helpful, professional, and made sure everything went smoothly during what can often be a hectic time. His support did not go unnoticed.\n\nOverall, we are more than pleased with our move. The entire experience, from leasing to move-in to maintenance, has exceeded our expectations. We are excited to be part of this community and are grateful for such a strong and supportive team.",
      "date": "2026-03-31",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_56d568fbf983fdf69b7fa441",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f14c3-eba1-73d5-951d-03ddfd899c7e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-eba1-73d5-951d-03ddfd899c7e",
        "storage_key": "property/5653950229381120/019f14c3-eba1-73d5-951d-03ddfd899c7e.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Latitude at Mallard Creek Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/Hp4me9OEo0U"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-a0d2-730a-ae7f-1d189684cd31",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "latitude-at-mallard-creek",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120"
    },
    {
      "lead_collector_id": "0198aa45-a135-717b-a125-cdedd7fefbe0",
      "lead_source": "FACEBOOK_ADS",
      "name": "latitude-at-mallard-creek",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120"
    },
    {
      "lead_collector_id": "0198aa45-a198-70be-be42-0c867f25c3f9",
      "lead_source": "LANDING_PAGE",
      "name": "latitude-at-mallard-creek",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "discover-one-bedroom-apartments-for-rent-charlotte-nc",
      "search_query": "One Bedroom Apartments For Rent In Charlotte NC",
      "category": "Floorplan",
      "h1_title": "Discover One Bedroom Apartments For Rent In Charlotte NC",
      "h2_subtitle": "Latitude at Mallard Creek offers spacious one-bedroom apartments in the vibrant University area. Enjoy modern amenities and a prime location near UNC Charlotte.",
      "page_copy": "Latitude at Mallard Creek is your gateway to comfortable living with our one bedroom apartments for rent in Charlotte NC. Located just 1.5 miles from UNC Charlotte, our community is perfect for students and professionals alike. Enjoy the convenience of high-speed internet access, stainless steel appliances, and walk-in closets. Our smoke-free apartments feature hardwood floors and granite countertops, providing a modern and stylish living space.\\n\\nRelax and unwind in our resort-inspired outdoor swimming pool or socialize in the clubhouse. With a private poolside kitchen, you can entertain friends and family in style. Latitude at Mallard Creek is managed by American Landmark and is part of the Charlotte-Mecklenburg attendance zone. Experience the ultimate lifestyle in our one bedroom apartments for rent in Charlotte NC, where comfort meets convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | One Bedroom Apartments For Rent In Charlotte NC",
      "seo_description": "Explore one bedroom apartments for rent in Charlotte NC at Latitude at Mallard Creek. Enjoy modern amenities and a prime location near UNC Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "explore-two-bedrooms-apartments-for-rent-charlotte-nc",
      "search_query": "Two Bedrooms Apartments For Rent In Charlotte NC",
      "category": "Floorplan",
      "h1_title": "Explore Two Bedrooms Apartments For Rent In Charlotte NC",
      "h2_subtitle": "Latitude at Mallard Creek offers spacious two-bedroom apartments in a prime location. Enjoy modern amenities and easy access to UNC Charlotte.",
      "page_copy": "Latitude at Mallard Creek provides the perfect setting for those seeking two bedrooms apartments for rent in Charlotte NC. Our community is ideally situated just 1.5 miles from UNC Charlotte, making it a convenient choice for students and professionals. Each apartment features high-speed internet access, stainless steel appliances, and walk-in closets, ensuring a comfortable and modern living experience.\\n\\nResidents can enjoy our resort-inspired outdoor swimming pool and socialize in the clubhouse. The private poolside kitchen is perfect for entertaining guests. Managed by American Landmark, Latitude at Mallard Creek is part of the Charlotte-Mecklenburg attendance zone. Discover the ultimate lifestyle in our two bedrooms apartments for rent in Charlotte NC, where convenience meets comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Two Bedrooms Apartments For Rent In Charlotte NC",
      "seo_description": "Discover two bedrooms apartments for rent in Charlotte NC at Latitude at Mallard Creek. Enjoy modern amenities and a prime location near UNC Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "find-three-bedrooms-apartments-for-rent-charlotte-nc",
      "search_query": "Three Bedrooms Apartments For Rent In Charlotte NC",
      "category": "Floorplan",
      "h1_title": "Find Three Bedrooms Apartments For Rent In Charlotte NC",
      "h2_subtitle": "Latitude at Mallard Creek offers spacious three-bedroom apartments in a vibrant community. Enjoy upscale amenities and a convenient location near UNC Charlotte.",
      "page_copy": "Latitude at Mallard Creek is the ideal choice for those seeking three bedrooms apartments for rent in Charlotte NC. Located just 1.5 miles from UNC Charlotte, our community offers the perfect blend of convenience and comfort. Each apartment is equipped with high-speed internet access, stainless steel appliances, and walk-in closets, providing a modern and spacious living environment.\\n\\nResidents can take advantage of our resort-inspired outdoor swimming pool and the clubhouse social room for relaxation and entertainment. The private poolside kitchen is perfect for hosting gatherings. Managed by American Landmark, Latitude at Mallard Creek is part of the Charlotte-Mecklenburg attendance zone. Experience the ultimate lifestyle in our three bedrooms apartments for rent in Charlotte NC, where luxury meets convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Three Bedrooms Apartments For Rent In Charlotte NC",
      "seo_description": "Explore three bedrooms apartments for rent in Charlotte NC at Latitude at Mallard Creek. Enjoy upscale amenities and a prime location near UNC Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Pool",
      "h2_subtitle": "Latitude at Mallard Creek offers luxurious apartments with a resort-inspired pool. Enjoy a vibrant community and modern amenities near UNC Charlotte.",
      "page_copy": "Latitude at Mallard Creek is your destination for apartments for rent near me with pool, offering a refreshing escape in the heart of Charlotte. Our community is conveniently located just 1.5 miles from UNC Charlotte, making it an ideal choice for students and professionals. Enjoy the luxury of our resort-inspired outdoor swimming pool, perfect for cooling off on hot days or relaxing with friends.\\n\\nIn addition to the pool, residents can take advantage of our fitness center, clubhouse, and dog park, ensuring a well-rounded lifestyle. Managed by American Landmark, Latitude at Mallard Creek provides a vibrant community atmosphere with modern amenities. Experience the ultimate in comfort and convenience with our apartments for rent near me with pool, where relaxation meets style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent Near Me with Pool",
      "seo_description": "Find apartments for rent near me with pool at Latitude at Mallard Creek. Enjoy a resort-inspired pool and modern amenities near UNC Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "Latitude at Mallard Creek offers modern apartments with a state-of-the-art fitness center. Enjoy a vibrant lifestyle near UNC Charlotte.",
      "page_copy": "Latitude at Mallard Creek is your ideal choice for apartments for rent near me with fitness center, providing a perfect blend of comfort and convenience. Located just 1.5 miles from UNC Charlotte, our community is designed for those who value an active lifestyle. Our state-of-the-art fitness center is equipped to meet all your workout needs, ensuring you stay fit and healthy.\\n\\nIn addition to the fitness center, residents can enjoy our resort-inspired pool, clubhouse, and dog park, creating a well-rounded living experience. Managed by American Landmark, Latitude at Mallard Creek offers a vibrant community atmosphere with modern amenities. Discover the ultimate lifestyle with our apartments for rent near me with fitness center, where health and relaxation come together.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Find apartments for rent near me with fitness center at Latitude at Mallard Creek. Enjoy a state-of-the-art fitness center and modern amenities near UNC Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-dog-park",
      "search_query": "Apartments For Rent Near Me with Dog Park",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Dog Park",
      "h2_subtitle": "Latitude at Mallard Creek offers pet-friendly apartments with a dedicated dog park. Enjoy a vibrant community near UNC Charlotte.",
      "page_copy": "Latitude at Mallard Creek is your perfect choice for apartments for rent near me with dog park, offering a pet-friendly environment in Charlotte. Just 1.5 miles from UNC Charlotte, our community is ideal for pet owners seeking convenience and comfort. The dog park provides a safe and fun space for your furry friends to play and socialize.\\n\\nIn addition to the dog park, residents can enjoy our resort-inspired pool, fitness center, and clubhouse, ensuring a comprehensive living experience. Managed by American Landmark, Latitude at Mallard Creek offers a vibrant community with modern amenities. Experience the ultimate lifestyle with our apartments for rent near me with dog park, where pets and people thrive together.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent Near Me with Dog Park",
      "seo_description": "Find apartments for rent near me with dog park at Latitude at Mallard Creek. Enjoy a pet-friendly community and modern amenities near UNC Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-charlotte-nc-near-fresenius-medical-care",
      "search_query": "Apartments For Rent In Charlotte NC Near Fresenius Medical Care at Cmc University",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Charlotte NC Near Fresenius Medical Care at Cmc University",
      "h2_subtitle": "Latitude at Mallard Creek offers convenient living near Fresenius Medical Care at Cmc University. Enjoy modern amenities and a prime location in Charlotte.",
      "page_copy": "Latitude at Mallard Creek is your ideal choice for apartments for rent in Charlotte NC near Fresenius Medical Care at Cmc University. Located in the vibrant University area, our community offers easy access to healthcare facilities and the convenience of being just 1.5 miles from UNC Charlotte. Our spacious one, two, and three-bedroom apartments are designed for comfort and style, featuring modern amenities like stainless steel appliances, granite countertops, and hardwood floors.\\n\\nResidents can enjoy a range of community amenities, including a resort-inspired pool, fitness center, and clubhouse, perfect for relaxation and socializing. Managed by American Landmark, Latitude at Mallard Creek provides a vibrant community atmosphere with all the conveniences of modern living. Discover the ultimate lifestyle with our apartments for rent in Charlotte NC near Fresenius Medical Care at Cmc University, where location and luxury meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent In Charlotte NC Near Fresenius Medical Care at Cmc University",
      "seo_description": "Find apartments for rent in Charlotte NC near Fresenius Medical Care at Cmc University at Latitude at Mallard Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-charlotte-nc-near-atrium-health",
      "search_query": "Apartments For Rent In Charlotte NC Near Atrium Health University City",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Charlotte NC Near Atrium Health University City",
      "h2_subtitle": "Latitude at Mallard Creek offers convenient living near Atrium Health University City. Enjoy modern amenities and a prime location in Charlotte.",
      "page_copy": "Latitude at Mallard Creek is your perfect choice for apartments for rent in Charlotte NC near Atrium Health University City. Our community is ideally located in the University area, providing easy access to a broad range of healthcare services, including 24/7 emergency care and specialty medical services. Our spacious one, two, and three-bedroom apartments are designed for comfort and style, featuring modern amenities like stainless steel appliances, granite countertops, and hardwood floors.\\n\\nResidents can enjoy a variety of community amenities, such as a resort-inspired pool, fitness center, and clubhouse, perfect for relaxation and socializing. Managed by American Landmark, Latitude at Mallard Creek offers a vibrant community atmosphere with all the conveniences of modern living. Discover the ultimate lifestyle with our apartments for rent in Charlotte NC near Atrium Health University City, where location and luxury meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent In Charlotte NC Near Atrium Health University City",
      "seo_description": "Find apartments for rent in Charlotte NC near Atrium Health University City at Latitude at Mallard Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "explore-apartments-rent-charlotte-nc-near-hospitalist",
      "search_query": "Apartments For Rent In Charlotte NC Near Carolinas Hospitalist Group",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Charlotte NC Near Carolinas Hospitalist Group",
      "h2_subtitle": "Latitude at Mallard Creek offers convenient living near Carolinas Hospitalist Group. Enjoy modern amenities and a prime location in Charlotte.",
      "page_copy": "Latitude at Mallard Creek is your ideal choice for apartments for rent in Charlotte NC near Carolinas Hospitalist Group. Our community is perfectly situated in the University area, providing easy access to healthcare professionals and services. Our spacious one, two, and three-bedroom apartments are designed for comfort and style, featuring modern amenities like stainless steel appliances, granite countertops, and hardwood floors.\\n\\nResidents can enjoy a variety of community amenities, such as a resort-inspired pool, fitness center, and clubhouse, perfect for relaxation and socializing. Managed by American Landmark, Latitude at Mallard Creek offers a vibrant community atmosphere with all the conveniences of modern living. Discover the ultimate lifestyle with our apartments for rent in Charlotte NC near Carolinas Hospitalist Group, where location and luxury meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent In Charlotte NC Near Carolinas Hospitalist Group",
      "seo_description": "Find apartments for rent in Charlotte NC near Carolinas Hospitalist Group at Latitude at Mallard Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-charlotte-nc-near-hunter-woods",
      "search_query": "Apartments For Rent In Charlotte NC Near Hunter Woods Nursing and Rehabilitation Center",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Charlotte NC Near Hunter Woods Nursing and Rehabilitation Center",
      "h2_subtitle": "Latitude at Mallard Creek offers convenient living near Hunter Woods Nursing and Rehabilitation Center. Enjoy modern amenities and a prime location in Charlotte.",
      "page_copy": "Latitude at Mallard Creek is your ideal choice for apartments for rent in Charlotte NC near Hunter Woods Nursing and Rehabilitation Center. Our community is perfectly situated in the University area, providing easy access to senior healthcare services, including post-acute care and Alzheimer's care. Our spacious one, two, and three-bedroom apartments are designed for comfort and style, featuring modern amenities like stainless steel appliances, granite countertops, and hardwood floors.\\n\\nResidents can enjoy a variety of community amenities, such as a resort-inspired pool, fitness center, and clubhouse, perfect for relaxation and socializing. Managed by American Landmark, Latitude at Mallard Creek offers a vibrant community atmosphere with all the conveniences of modern living. Discover the ultimate lifestyle with our apartments for rent in Charlotte NC near Hunter Woods Nursing and Rehabilitation Center, where location and luxury meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent In Charlotte NC Near Hunter Woods Nursing and Rehabilitation Center",
      "seo_description": "Find apartments for rent in Charlotte NC near Hunter Woods Nursing and Rehabilitation Center at Latitude at Mallard Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "explore-apartments-rent-charlotte-nc-near-novant-health",
      "search_query": "Apartments For Rent In Charlotte NC Near Novant Health Huntersville Medical Center",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Charlotte NC Near Novant Health Huntersville Medical Center",
      "h2_subtitle": "Latitude at Mallard Creek offers convenient living near Novant Health Huntersville Medical Center. Enjoy modern amenities and a prime location in Charlotte.",
      "page_copy": "Latitude at Mallard Creek is your ideal choice for apartments for rent in Charlotte NC near Novant Health Huntersville Medical Center. Our community is perfectly situated in the University area, providing easy access to healthcare services and facilities. Our spacious one, two, and three-bedroom apartments are designed for comfort and style, featuring modern amenities like stainless steel appliances, granite countertops, and hardwood floors.\\n\\nResidents can enjoy a variety of community amenities, such as a resort-inspired pool, fitness center, and clubhouse, perfect for relaxation and socializing. Managed by American Landmark, Latitude at Mallard Creek offers a vibrant community atmosphere with all the conveniences of modern living. Discover the ultimate lifestyle with our apartments for rent in Charlotte NC near Novant Health Huntersville Medical Center, where location and luxury meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent In Charlotte NC Near Novant Health Huntersville Medical Center",
      "seo_description": "Find apartments for rent in Charlotte NC near Novant Health Huntersville Medical Center at Latitude at Mallard Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-charlotte-nc-uncc",
      "search_query": "Apartments For Rent In Charlotte NC Near University of North Carolina at Charlotte",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Charlotte NC Near University of North Carolina at Charlotte",
      "h2_subtitle": "Latitude at Mallard Creek offers convenient living near UNC Charlotte. Enjoy modern amenities and a prime location in the University area.",
      "page_copy": "Latitude at Mallard Creek is your ideal choice for apartments for rent in Charlotte NC near University of North Carolina at Charlotte. Our community is perfectly situated just 1.5 miles from UNC Charlotte, providing easy access for students and faculty. Our spacious one, two, and three-bedroom apartments are designed for comfort and style, featuring modern amenities like stainless steel appliances, granite countertops, and hardwood floors.\\n\\nResidents can enjoy a variety of community amenities, such as a resort-inspired pool, fitness center, and clubhouse, perfect for relaxation and socializing. Managed by American Landmark, Latitude at Mallard Creek offers a vibrant community atmosphere with all the conveniences of modern living. Discover the ultimate lifestyle with our apartments for rent in Charlotte NC near University of North Carolina at Charlotte, where location and luxury meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent In Charlotte NC Near University of North Carolina at Charlotte",
      "seo_description": "Find apartments for rent in Charlotte NC near University of North Carolina at Charlotte at Latitude at Mallard Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-charlotte-nc-near-cato-college",
      "search_query": "Apartments For Rent In Charlotte NC Near Cato Middle College High",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Charlotte NC Near Cato Middle College High",
      "h2_subtitle": "Latitude at Mallard Creek offers convenient living near Cato Middle College High. Enjoy modern amenities and a prime location in Charlotte.",
      "page_copy": "Latitude at Mallard Creek is your ideal choice for apartments for rent in Charlotte NC near Cato Middle College High. Our community is perfectly situated in the University area, providing easy access for students and families. Our spacious one, two, and three-bedroom apartments are designed for comfort and style, featuring modern amenities like stainless steel appliances, granite countertops, and hardwood floors.\\n\\nResidents can enjoy a variety of community amenities, such as a resort-inspired pool, fitness center, and clubhouse, perfect for relaxation and socializing. Managed by American Landmark, Latitude at Mallard Creek offers a vibrant community atmosphere with all the conveniences of modern living. Discover the ultimate lifestyle with our apartments for rent in Charlotte NC near Cato Middle College High, where location and luxury meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent In Charlotte NC Near Cato Middle College High",
      "seo_description": "Find apartments for rent in Charlotte NC near Cato Middle College High at Latitude at Mallard Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-charlotte-nc-near-cpcc-merancas",
      "search_query": "Apartments For Rent In Charlotte NC Near Central Piedmont Community College - Merancas Campus",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Charlotte NC Near Central Piedmont Community College - Merancas Campus",
      "h2_subtitle": "Latitude at Mallard Creek offers convenient living near Central Piedmont Community College - Merancas Campus. Enjoy modern amenities and a prime location in Charlotte.",
      "page_copy": "Latitude at Mallard Creek is your ideal choice for apartments for rent in Charlotte NC near Central Piedmont Community College - Merancas Campus. Our community is perfectly situated in the University area, providing easy access for students and faculty. Our spacious one, two, and three-bedroom apartments are designed for comfort and style, featuring modern amenities like stainless steel appliances, granite countertops, and hardwood floors.\\n\\nResidents can enjoy a variety of community amenities, such as a resort-inspired pool, fitness center, and clubhouse, perfect for relaxation and socializing. Managed by American Landmark, Latitude at Mallard Creek offers a vibrant community atmosphere with all the conveniences of modern living. Discover the ultimate lifestyle with our apartments for rent in Charlotte NC near Central Piedmont Community College - Merancas Campus, where location and luxury meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent In Charlotte NC Near Central Piedmont Community College - Merancas Campus",
      "seo_description": "Find apartments for rent in Charlotte NC near Central Piedmont Community College - Merancas Campus at Latitude at Mallard Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-charlotte-nc-near-cpcc-harris",
      "search_query": "Apartments For Rent In Charlotte NC Near Central Piedmont Community College - Harris Campus",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Charlotte NC Near Central Piedmont Community College - Harris Campus",
      "h2_subtitle": "Latitude at Mallard Creek offers convenient living near Central Piedmont Community College - Harris Campus. Enjoy modern amenities and a prime location in Charlotte.",
      "page_copy": "Latitude at Mallard Creek is your ideal choice for apartments for rent in Charlotte NC near Central Piedmont Community College - Harris Campus. Our community is perfectly situated in the University area, providing easy access for students and faculty. Our spacious one, two, and three-bedroom apartments are designed for comfort and style, featuring modern amenities like stainless steel appliances, granite countertops, and hardwood floors.\\n\\nResidents can enjoy a variety of community amenities, such as a resort-inspired pool, fitness center, and clubhouse, perfect for relaxation and socializing. Managed by American Landmark, Latitude at Mallard Creek offers a vibrant community atmosphere with all the conveniences of modern living. Discover the ultimate lifestyle with our apartments for rent in Charlotte NC near Central Piedmont Community College - Harris Campus, where location and luxury meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent In Charlotte NC Near Central Piedmont Community College - Harris Campus",
      "seo_description": "Find apartments for rent in Charlotte NC near Central Piedmont Community College - Harris Campus at Latitude at Mallard Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-charlotte-nc-near-stoney-creek",
      "search_query": "Apartments For Rent In Charlotte NC Near Stoney Creek Elementary School",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Charlotte NC Near Stoney Creek Elementary School",
      "h2_subtitle": "Latitude at Mallard Creek offers family-friendly living near Stoney Creek Elementary School. Enjoy spacious floor plans and modern amenities in Charlotte.",
      "page_copy": "Latitude at Mallard Creek is the perfect choice for families seeking apartments for rent in Charlotte NC near Stoney Creek Elementary School. Located just 4.9 km from the school, our community offers convenient access to quality education within the Jefferson County School District R-1. Our spacious one, two, and three-bedroom apartments provide the ideal home base for families, featuring modern amenities like stainless steel appliances, granite countertops, and hardwood floors.\\n\\nResidents can enjoy a variety of community amenities, such as a resort-inspired pool, fitness center, and clubhouse, perfect for family relaxation and socializing. Managed by American Landmark, Latitude at Mallard Creek offers a vibrant community atmosphere with all the conveniences of modern living. Discover the ultimate family lifestyle with our apartments for rent in Charlotte NC near Stoney Creek Elementary School, where education and comfort meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent In Charlotte NC Near Stoney Creek Elementary School",
      "seo_description": "Find family-friendly apartments for rent in Charlotte NC near Stoney Creek Elementary School at Latitude at Mallard Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-tmsa-charlotte",
      "search_query": "Apartments For Rent In Charlotte NC Near TMSA Charlotte Elementary School - The Math and Science Academy of Charlotte",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Charlotte NC Near TMSA Charlotte Elementary School",
      "h2_subtitle": "Latitude at Mallard Creek offers family-friendly living near TMSA Charlotte Elementary School. Enjoy spacious floor plans and modern amenities in Charlotte.",
      "page_copy": "Latitude at Mallard Creek is the perfect choice for families seeking apartments for rent in Charlotte NC near TMSA Charlotte Elementary School - The Math and Science Academy of Charlotte. Located just 6.0 km from the school, our community offers convenient access to a top-tier STEM education. Our spacious one, two, and three-bedroom apartments provide the ideal home base for families, featuring modern amenities like stainless steel appliances, granite countertops, and hardwood floors.\\n\\nResidents can enjoy a variety of community amenities, such as a resort-inspired pool, fitness center, and clubhouse, perfect for family relaxation and socializing. Managed by American Landmark, Latitude at Mallard Creek offers a vibrant community atmosphere with all the conveniences of modern living. Discover the ultimate family lifestyle with our apartments for rent in Charlotte NC near TMSA Charlotte Elementary School, where education and comfort meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent In Charlotte NC Near TMSA Charlotte Elementary School",
      "seo_description": "Find family-friendly apartments for rent in Charlotte NC near TMSA Charlotte Elementary School at Latitude at Mallard Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-charlotte-nc-near-carl-furr",
      "search_query": "Apartments For Rent In Charlotte NC Near Carl A Furr Elementary School",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Charlotte NC Near Carl A Furr Elementary School",
      "h2_subtitle": "Latitude at Mallard Creek offers family-friendly living near Carl A Furr Elementary School. Enjoy spacious floor plans and modern amenities in Charlotte.",
      "page_copy": "Latitude at Mallard Creek is the perfect choice for families seeking apartments for rent in Charlotte NC near Carl A Furr Elementary School. Located just 10.3 km from the school, our community offers convenient access to quality education within the Cabarrus County Schools district. Our spacious one, two, and three-bedroom apartments provide the ideal home base for families, featuring modern amenities like stainless steel appliances, granite countertops, and hardwood floors.\\n\\nResidents can enjoy a variety of community amenities, such as a resort-inspired pool, fitness center, and clubhouse, perfect for family relaxation and socializing. Managed by American Landmark, Latitude at Mallard Creek offers a vibrant community atmosphere with all the conveniences of modern living. Discover the ultimate family lifestyle with our apartments for rent in Charlotte NC near Carl A Furr Elementary School, where education and comfort meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent In Charlotte NC Near Carl A Furr Elementary School",
      "seo_description": "Find family-friendly apartments for rent in Charlotte NC near Carl A Furr Elementary School at Latitude at Mallard Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-charlotte-nc-university-city-north",
      "search_query": "Apartments For Rent In Charlotte NC Near University City North Neighborhood",
      "category": "Location",
      "h1_title": "Discover Apartments For Rent In Charlotte NC Near University City North Neighborhood",
      "h2_subtitle": "Latitude at Mallard Creek features spacious one, two, and three-bedroom apartments. Located near UNC Charlotte, enjoy convenient access to education and entertainment.",
      "page_copy": "Latitude at Mallard Creek offers a variety of apartments for rent in Charlotte, NC near University City North Neighborhood. Our community features modern amenities and a welcoming atmosphere, perfect for students and professionals alike. With easy access to UNC Charlotte, residents can enjoy a short commute to campus and nearby attractions. \n\nOur apartments are designed with your comfort in mind, offering spacious layouts and contemporary finishes. Whether you're looking for a cozy one-bedroom or a larger three-bedroom space, Latitude at Mallard Creek has the perfect home for you. Experience the vibrant lifestyle of Charlotte while enjoying the tranquility of our community. Visit us today to find your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent In Charlotte NC Near University City North Neighborhood",
      "seo_description": "Explore Latitude at Mallard Creek for apartments for rent in Charlotte, NC near University City North Neighborhood. Perfect for students and professionals alike.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-charlotte-nc-near-queen-city-stem-school",
      "search_query": "Apartments For Rent In Charlotte NC Near Queen City Stem School",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Charlotte NC Near Queen City Stem School",
      "h2_subtitle": "Latitude at Mallard Creek offers a variety of spacious floor plans. Enjoy modern amenities and a convenient location near UNC Charlotte and Queen City Stem School.",
      "page_copy": "Latitude at Mallard Creek features one, two, and three-bedroom apartments designed for comfort and style. Located in the vibrant city of Charlotte, NC, our community is perfect for those seeking proximity to educational institutions like Queen City Stem School and UNC Charlotte. Each apartment is equipped with modern amenities to enhance your living experience, including a fully-equipped kitchen, in-unit laundry, and private balconies. Residents can also enjoy community features such as a swimming pool, fitness center, and clubhouse. With easy access to major highways and public transportation, Latitude at Mallard Creek is an ideal choice for anyone looking for apartments for rent in Charlotte, NC near Queen City Stem School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
      "featured_image_media": {
        "alt_text": "Large, sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by a paved patio and apartment buildings.",
        "public_id": "019f6c0f-7124-779c-8706-dc8bb79dc800",
        "storage_key": "property/5653950229381120/019f6c0f-7124-779c-8706-dc8bb79dc800.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
      "blank_image_media": {
        "alt_text": "Building exterior of luxury apartment complex with manicured landscaping.",
        "public_id": "019f6c0f-7deb-7047-8111-955377ee4fb2",
        "storage_key": "property/5653950229381120/019f6c0f-7deb-7047-8111-955377ee4fb2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Latitude at Mallard Creek | Apartments For Rent In Charlotte NC Near Queen City Stem School",
      "seo_description": "Explore Latitude at Mallard Creek for apartments for rent in Charlotte, NC near Queen City Stem School. Enjoy modern amenities and a prime location near UNC Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5653950229381120",
      "source": "custom",
      "page_item_url": "1",
      "search_query": "",
      "category": "",
      "h1_title": "",
      "h2_subtitle": "",
      "page_copy": "",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2170"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471481"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a35\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a35\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4897194"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WQK3XQR"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443889465"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "20ed49011f176f12"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/d7p1odggvkx"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/7c04e0f3-65d5-4335-be37-68d23a5af5b4"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "980-463-9425"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InljY2EwVHQrWEgrdzhvVXFPT25qaWc9PSIsInZhbHVlIjoiaGNTK1h5SGNOQys5WXROa0g0UTQwdz09IiwibWFjIjoiMzAzZjE1N2M3NmFmMGE5NzJlMjViNjE5NTNhNjg1OGM0ZTJjZjkzYWJmMWQ2MmJiMjYxZDY5ZTMwNWVhZWZjMiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2170",
  "custom_repli_id": "2376471481",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a35\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a35\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4897194",
  "custom_google_gtm_id": "GTM-WQK3XQR",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443889465",
  "custom_knock_community_id": "20ed49011f176f12",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/d7p1odggvkx",
  "custom_self_guided_tour_url": "https://selftournow.com/property/7c04e0f3-65d5-4335-be37-68d23a5af5b4",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "980-463-9425",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InljY2EwVHQrWEgrdzhvVXFPT25qaWc9PSIsInZhbHVlIjoiaGNTK1h5SGNOQys5WXROa0g0UTQwdz09IiwibWFjIjoiMzAzZjE1N2M3NmFmMGE5NzJlMjViNjE5NTNhNjg1OGM0ZTJjZjkzYWJmMWQ2MmJiMjYxZDY5ZTMwNWVhZWZjMiJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "d7a58aa9-13cb-476c-96c5-8585337c780c",
  "custom_audioeye_site_hash": "3eccf2fa77534f43c054ae5d25689496"
};

export const generatedAt = '2026-11-03T20:34:59.285Z';
